import React, { forwardRef, Children, createContext, useState, useRef, useLayoutEffect, useEffect, useContext, PureComponent, createRef } from 'react';
import Imgix, { Source as Source$1, Picture as Picture$1 } from 'react-imgix';
import classnames from 'classnames';
import hash from 'object-hash';
import isNode from 'in-node';
import hashIndex from 'hash-index';
import range from 'lodash/range';
import debounce from 'lodash/debounce';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Masked from 'react-text-mask';
import omit from 'lodash/omit';
import isUndefined from 'lodash/isUndefined';
import { Transition } from 'react-transition-group';
import { toMomentObject, SingleDatePicker, DateRangePicker } from 'react-dates';
import { format, setMinutes, setHours } from 'date-fns';
import { DateTime } from 'luxon';
import camelCase from 'lodash/camelCase';
import once from 'lodash/once';
import Measure from 'react-measure';
import pick from 'lodash/pick';
import times from 'lodash/times';
import flatten from 'lodash/flatten';
import isInteger from 'lodash/isInteger';
import sortBy from 'lodash/sortBy';
import pickBy from 'lodash/pickBy';
import toPairs from 'lodash/toPairs';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import upperFirst from 'lodash/upperFirst';
import uniq from 'lodash/uniq';
import ScrollLock, { TouchScrollable } from 'react-scrolllock';
export { TouchScrollable } from 'react-scrolllock';
import ReactModal from 'react-modal';
import { useSpring, animated } from 'react-spring';
import { Slider as Slider$1, Rail as Rail$1, Handles, Tracks } from 'react-compound-slider';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import Autosuggest from 'react-autosuggest';
import StarRatings from '@deal/react-star-ratings';
import Observer from '@researchgate/react-intersection-observer';
import Tippy from '@tippyjs/react';
import Tippy$1 from '@tippyjs/react/headless';
import ReactTable from 'react-table';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var breakpoints = {"breakpoint-xs":"(min-width: 360px)","breakpoint-sm":"(min-width: 768px)","breakpoint-md":"(min-width: 960px)","breakpoint-lg":"(min-width: 1200px)","breakpoint-xlg":"(min-width: 1440px)","breakpoint-xxlg":"(min-width: 1600px)","breakpointXs":"(min-width: 360px)","breakpointSm":"(min-width: 768px)","breakpointMd":"(min-width: 960px)","breakpointLg":"(min-width: 1200px)","breakpointXlg":"(min-width: 1440px)","breakpointXxlg":"(min-width: 1600px)"};

function addDefaultImgixParams(params) {
  return Object.assign({
    auto: ['compress', 'format'],
    ch: ['Width', 'DPR', 'Save-Data'] // Default to setting all client-hints (https://docs.imgix.com/apis/url/format/ch)

  }, params);
}

var Image = function Image(props) {
  var imgixParams = props.imgixParams,
      className = props.className,
      _a = props.lazyLoad,
      lazyLoad = _a === void 0 ? true : _a,
      defaultHtmlAttributes = props.htmlAttributes,
      rest = __rest(props, ["imgixParams", "className", "lazyLoad", "htmlAttributes"]);

  var htmlAttributes = __assign({}, defaultHtmlAttributes);

  var sizes = []; // Order matters

  var responsiveAreasPropNames = ['sizeXxlg', 'sizeXlg', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXs'];
  responsiveAreasPropNames.forEach(function (propName) {
    var breakpointName = propName.slice(4).toLowerCase() || null; // "SizeXs" => "xs"

    var mediaQuery = breakpoints["breakpoint-" + breakpointName] || undefined; // "xs"  => "360px"

    if (propName in props) {
      // @ts-ignore TS can't tell this prop exists
      sizes.push(mediaQuery + " " + props[propName]);
    }
  });

  if (props.size) {
    sizes.push(props.size);
  }

  var formattedSizes = sizes.join(', ');
  var imgixParamsWithDefault = addDefaultImgixParams(imgixParams); // When lazy-loading is enabled, LazySizes directly mutates the DOM node, so we do not allow
  //  React to overwrite attributes/props set by that library (src, srcset, sizes, and className).
  //  This is important for render "purity", especially when hydrating a SSR response.
  //
  // For example: Images are eagerly loaded as soon as the initial HTML is parsed (LazySizes
  //  is initialized outside of the React render pipeline). Therefore, it's possible for images
  //  to already be loaded before the corresponding <Image> tag is hydrated/rendered on the client
  //  side for the first time. LazySizes will change the classnames independently of React, so by
  //  the time `React.hydrate` is called the document HTML may have been mutated. In that case, we
  //  need to set the appropriate className (`lazyloading` or `lazyloaded` instead of `lazyload`)
  //  in order to match the DOM. In general, we ensure certain classes matches those currently set
  //  in the DOM since that state is only partially managed by React.

  var lazySizesClassNames = ['ls-is-cached', 'lazyloading', 'lazyloaded', 'lazypreload', 'lazyerror', 'lazyautosizes'];
  var existingLazySizesClasses = []; // We generate a unique identifier based on the props, in order to find this element in the DOM
  //  during client-side rehydration. There are edge-cases where this won't work (multiple images
  //  with identical props), so we use a className as a "best-effort". In order to generate truly
  //  unique IDs we could theoretically hash the path to the React component from the root node.
  //  That data is not currently exposed by React.
  //
  // See: https://github.com/facebook/react/issues/15435

  var hashedPropsClassName = "image-" + hash(props).slice(0, 8);

  if (lazyLoad && !isNode) {
    // Get the DOM node of an element that matches this component's props exactly. It may not be
    //  the same element as we're actively rendering now: there's an edge case where the same image
    //  is rendered twice, once below-the-fold and once above-the-fold, in which case they will
    //  have different LazySizes classnames and attributes. In that scenario we prefer the image that
    //  is the "most loaded". The markup rendered by React will not match the markup in the DOM, so
    //  we have to suppress the warnings from React hydration.
    var loadingStateClassNames_1 = ['lazyload', 'lazypreload', 'lazyloading', 'lazyloaded'];
    var matchingDomNodes = Array.from(document.getElementsByClassName(hashedPropsClassName));
    var mostLoadedDomNode = matchingDomNodes.sort(function (a, b) {
      var stateOfImageA = loadingStateClassNames_1.findIndex(function (className) {
        return a.classList.contains(className);
      });
      var stateOfImageB = loadingStateClassNames_1.findIndex(function (className) {
        return b.classList.contains(className);
      });
      return stateOfImageB - stateOfImageA;
    })[0];

    if (mostLoadedDomNode) {
      existingLazySizesClasses = Array.from(mostLoadedDomNode.classList).filter(function (className) {
        return lazySizesClassNames.indexOf(className) !== -1;
      }); // Allow LazySizes to manage `src`, `srcset`, and `sizes` itself.
      //  We set those attributes as `data-` attributes instead. LazySizes will manage converting
      //  those to the corresponding DOM attributes for us, so we always prefer the existing DOM
      //  attributes.

      htmlAttributes = __assign({
        src: mostLoadedDomNode.getAttribute('src') || undefined,
        srcSet: mostLoadedDomNode.getAttribute('srcset') || undefined,
        sizes: mostLoadedDomNode.getAttribute('sizes') || undefined,
        suppressHydrationWarning: matchingDomNodes.length > 1
      }, htmlAttributes);
    }
  }

  var classNames = classnames.apply(void 0, __spreadArrays([className, hashedPropsClassName, {
    lazyload: lazyLoad && existingLazySizesClasses.length === 0
  }], existingLazySizesClasses));
  return React.createElement(Imgix, __assign({
    htmlAttributes: htmlAttributes,
    sizes: formattedSizes || undefined,
    className: classNames,
    attributeConfig: lazyLoad ? {
      src: 'data-src',
      srcSet: 'data-srcset',
      sizes: 'data-sizes'
    } : undefined,
    imgixParams: imgixParamsWithDefault
  }, rest));
};

var Source = function Source(_a) {
  var imgixParams = _a.imgixParams,
      props = __rest(_a, ["imgixParams"]);

  imgixParams = addDefaultImgixParams(imgixParams);
  return React.createElement(Source$1, __assign({
    imgixParams: imgixParams
  }, props));
};

var Picture = function Picture(props) {
  return React.createElement(Picture$1, __assign({}, props));
}; // Exports

var styles = {"avatar":"styles_avatar__gdIPG flex justify-center items-center","color-one":"styles_color-one__3fKEt","color-two":"styles_color-two__2_I6C","color-three":"styles_color-three__1exxQ","color-four":"styles_color-four__3L3_P","color-five":"styles_color-five__26LZl","colorOne":"styles_color-one__3fKEt","colorTwo":"styles_color-two__2_I6C","colorThree":"styles_color-three__1exxQ","colorFour":"styles_color-four__3L3_P","colorFive":"styles_color-five__26LZl"};

// We will apply one of these classes for users without avatars

var CLASS_PREFIX = 'color-';
var PALETTE = Object.keys(styles).filter(function (key) {
  return key.slice(0, CLASS_PREFIX.length) === CLASS_PREFIX;
}).map(function (className) {
  return styles[className];
}); // Convert the size prop to a pixel dimension so we can request properly sized avatar images

function sizeToDimension(size) {
  switch (size) {
    case 'small':
      return 24;

    case 'medium':
      return 32;

    case 'large':
      return 44;

    case 'xlarge':
      return 64;
  }
}
/**
 * Displays a chat participants photo/avatar, or a consistently colored circle with their initials
 */


var Avatar = function Avatar(_a) {
  var name = _a.name,
      hash = _a.hash,
      src = _a.src,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      _c = _a.trimNameToInitials,
      trimNameToInitials = _c === void 0 ? true : _c,
      className = _a.className,
      htmlAttributes = _a.htmlAttributes;
  var imageSize = typeof size === 'number' ? size : sizeToDimension(size);
  var classes = classnames(className, styles.avatar);

  if (src) {
    return React.createElement(Image, {
      src: src,
      height: imageSize,
      width: imageSize,
      className: classes,
      htmlAttributes: htmlAttributes
    });
  } else {
    // Concatenate first and last initials
    var names_1 = name.trim().split(' ');
    var initials = names_1.filter(function (_name, i) {
      return i === 0 || i === names_1.length - 1;
    }).map(function (name) {
      return name.charAt(0).toUpperCase();
    }).join('');
    var avatarLabel = trimNameToInitials ? initials : name; // Choose a consistent color for this user's avatar

    var color = PALETTE[hashIndex(hash || name, PALETTE.length || 1)];
    return React.createElement("div", __assign({
      className: classnames(color, classes),
      style: {
        height: imageSize + "px",
        width: imageSize + "px",
        flexBasis: imageSize + "px",
        lineHeight: imageSize + "px",
        fontSize: Math.round(imageSize / 2.2)
      }
    }, htmlAttributes), avatarLabel);
  }
};

var styles$1 = {"common":"styles_common__25RxR","success":"styles_success__mE3P6 styles_common__25RxR","info":"styles_info__1MUkN styles_common__25RxR","regular":"styles_regular__16FRp styles_common__25RxR","warning":"styles_warning__2l2bw styles_common__25RxR","danger":"styles_danger__22x-x styles_common__25RxR","primary":"styles_primary__QO-AI styles_common__25RxR"};

var Badge = function Badge(_a) {
  var className = _a.className,
      _b = _a.type,
      type = _b === void 0 ? 'primary' : _b,
      children = _a.children;
  var classes = classnames(styles$1[type], className);
  return React.createElement("span", {
    className: classes
  }, children);
};

var styles$2 = {"item":"styles_item__3Gv3F","none":"styles_none__3jj7_","extra-tight":"styles_extra-tight__9332O","tight":"styles_tight__3mrja","normal":"styles_normal__22KdM","loose":"styles_loose__3WIh9","extra-loose":"styles_extra-loose__3GTFd","extraTight":"styles_extra-tight__9332O","extraLoose":"styles_extra-loose__3GTFd"};

var Box = forwardRef(function (_a, ref) {
  var _b;

  var column = _a.column,
      wrap = _a.wrap,
      justify = _a.justify,
      items = _a.items,
      content = _a.content,
      _c = _a.spacing,
      spacing = _c === void 0 ? 'normal' : _c,
      className = _a.className,
      children = _a.children,
      props = _a.props; // Always include "flex", the spacing class,  and the custom class (if provided)

  var classes = classnames('flex', styles$2[spacing], className, (_b = {
    'flex-wrap': wrap,
    'flex-column': column
  }, _b["justify-" + justify] = !!justify, _b["items-" + items] = !!items, _b["content-" + content] = !!content, _b));
  return React.createElement("div", __assign({
    className: classes,
    ref: ref
  }, props), Children.map(children, function (child) {
    if (child && ( // Check if the child is a string or number before accessing ".type"
    typeof child === 'string' || typeof child === 'number' || // Child is a React element, but don't wrap BoxItem's or Fragments
    React.isValidElement(child) && child.type !== boxItemElement.type && child.type !== fragmentElement.type)) {
      return React.createElement(BoxItem, null, child);
    } else {
      return child;
    }
  }));
});

var BoxItem = function BoxItem(_a) {
  var _b;

  var className = _a.className,
      grow = _a.grow,
      shrink = _a.shrink,
      self = _a.self,
      rest = __rest(_a, ["className", "grow", "shrink", "self"]);

  var classes = classnames(styles$2.item, className, (_b = {}, _b["self-" + self] = !!self, _b));
  var style = {
    flexGrow: grow,
    flexShrink: shrink
  };
  return React.createElement("div", __assign({
    className: classes,
    style: style
  }, rest));
};

Box.Item = BoxItem; // Create a single BoxItem and use that for type comparisons
//   See: https://github.com/gaearon/react-hot-loader#checking-element-types

var boxItemElement = React.createElement(BoxItem, null);
var fragmentElement = React.createElement(React.Fragment, null);

var styles$3 = {"c-primary":"#f54e32","c-primary-hover":"#eb4225","c-primary-light":"#fef2f0","c-secondary":"#1e85e8","c-secondary-hover":"#1d6bba","c-secondary-light":"#e8f3fd","c-contrast":"#222222","c-contrast-hover":"#000000","c-contrast-light":"#f7f7f7","button":"styles_button__3Yr7O bold border-box align-middle items-center justify-center","normal-box-shadow":"styles_normal-box-shadow__ZDRl8","border":"styles_border__1lwcy","primary":"styles_primary__15nU3 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8","primary-outline":"styles_primary-outline__1SYQD styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","primary-light":"styles_primary-light__xaKw3 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","secondary":"styles_secondary__3o6Gs styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8","secondary-outline":"styles_secondary-outline__130vF styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","secondary-light":"styles_secondary-light__3Ws9k styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","contrast":"styles_contrast__2Br48 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8","contrast-outline":"styles_contrast-outline__1ebwC styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","contrast-light":"styles_contrast-light__31cg6 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","link":"styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","xsmall":"styles_xsmall__2YWfw","small":"styles_small__AIqd8","medium":"styles_medium__3Gg19","large":"styles_large__YVPD8","xlarge":"styles_xlarge__1Arun","primary-link":"styles_primary-link__328ZT styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","secondary-link":"styles_secondary-link__2PvCR styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","contrast-link":"styles_contrast-link__22RE4 styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","clear-black":"styles_clear-black__1w5uj styles_button__3Yr7O bold border-box align-middle items-center justify-center","success":"styles_success__21LEY styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8","destructive":"styles_destructive__2CJ2V styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8","cPrimary":"#f54e32","cPrimaryHover":"#eb4225","cPrimaryLight":"#fef2f0","cSecondary":"#1e85e8","cSecondaryHover":"#1d6bba","cSecondaryLight":"#e8f3fd","cContrast":"#222222","cContrastHover":"#000000","cContrastLight":"#f7f7f7","normalBoxShadow":"styles_normal-box-shadow__ZDRl8","primaryOutline":"styles_primary-outline__1SYQD styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","primaryLight":"styles_primary-light__xaKw3 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","secondaryOutline":"styles_secondary-outline__130vF styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","secondaryLight":"styles_secondary-light__3Ws9k styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","contrastOutline":"styles_contrast-outline__1ebwC styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","contrastLight":"styles_contrast-light__31cg6 styles_button__3Yr7O bold border-box align-middle items-center justify-center styles_normal-box-shadow__ZDRl8 styles_border__1lwcy","primaryLink":"styles_primary-link__328ZT styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","secondaryLink":"styles_secondary-link__2PvCR styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","contrastLink":"styles_contrast-link__22RE4 styles_link__3xbD4 styles_button__3Yr7O bold border-box align-middle items-center justify-center","clearBlack":"styles_clear-black__1w5uj styles_button__3Yr7O bold border-box align-middle items-center justify-center"};

/**
 * For Buttons with complex content (i.e. not just a string), we wrap each text node in a <span>
 * This allows us to style the children with accessors like :last-child
 */

var wrapChildTextNodesInSpans = function wrapChildTextNodesInSpans(children) {
  return React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return React.createElement("span", null, child);
    } else {
      return child;
    }
  });
};

var Button = function Button(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      disabled = _a.disabled,
      testId = _a.testId,
      className = _a.className,
      children = _a.children,
      rest = __rest(_a, ["variant", "size", "disabled", "testId", "className", "children"]);

  var classes = classnames(styles$3[variant], styles$3[size], className);
  return React.createElement("button", __assign({
    className: classes,
    disabled: disabled,
    "data-testid": testId
  }, rest), React.Children.count(children) > 1 ? wrapChildTextNodesInSpans(children) : children);
};

var styles$4 = {"wrapper":"styles_wrapper__2ir1k flex flex-auto","scrollable":"styles_scrollable__1UFnE flex flex-column","calendarWrapper":"styles_calendarWrapper__MBihy flex flex-auto","calendar":"styles_calendar__1-Na- flex-auto","cell":"styles_cell__18v5W","clickable":"styles_clickable__2H61J","hour":"styles_hour__2qXt8 flex justify-center"};

var MINUTES_IN_DAY = 1440;
function getDateRangeInclusive(startDate, endDate) {
  var datesBetween = [];
  var days = Math.floor(endDate.diff(startDate, 'days').days);

  for (var i = 0; i <= days; i++) {
    datesBetween.push(startDate.plus({
      days: i
    }));
  }

  return datesBetween;
}
function getTimeSlots(timeIntervalInMinutes, days) {
  var timeSlots = [];
  /**
   * Gets tick marks for vertical axis based on given interval
   * e.g. 15 min intervals will be [{hour: 0, minute: 0},{hour: 0, minute: 15},{ hour: 0, minute: 30}... {hour: 24, minute: 0}] length = 96
   * e.g. 30 min intervals will be [{hour: 0, minute: 0},{hour: 0, minute: 30},{ hour: 1, minute: 0}... {hour: 24, minute: 0}] length = 48
   */

  var timeline = range(0, MINUTES_IN_DAY / timeIntervalInMinutes, 1).map(function (interval) {
    var minutes = interval * timeIntervalInMinutes;
    return {
      hour: Math.floor(minutes / 60),
      minute: minutes % 60
    };
  });
  /**
   * Map over every interval for every day to create all the "time slots"
   * each time slot starts at the time specified and ends "timeIntervalInMinutes" later
   */

  days.forEach(function (day, column) {
    return timeline.forEach(function (_a, row) {
      var hour = _a.hour,
          minute = _a.minute;
      var startTime = day.set({
        hour: hour,
        minute: minute
      });
      timeSlots.push({
        column: column + 1,
        row: row + 1,
        startTime: startTime,
        endTime: startTime.plus({
          minutes: timeIntervalInMinutes
        })
      });
    });
  });
  return timeSlots;
}

var styles$5 = {"breakpoint-md":"(min-width: 960px)","weekdays":"styles_weekdays__7ZPbD flex","weekday":"styles_weekday__39OfW mb1","date":"styles_date__AYtP7 mb2","timezone":"styles_timezone__3cq-q pb2 flex items-end justify-center","dayHeader":"styles_dayHeader__1QpkV flex flex-column items-center justify-center","active":"styles_active__3uT03","breakpointMd":"(min-width: 960px)"};

var WeekdayHeader = function WeekdayHeader(_a) {
  var weekdays = _a.weekdays,
      onWeekdaySelected = _a.onWeekdaySelected,
      isMobile = _a.isMobile,
      calendarViewStartsAt = _a.calendarViewStartsAt;
  return React.createElement("div", {
    className: styles$5.weekdays
  }, React.createElement("div", {
    className: styles$5.timezone
  }, weekdays[0].offsetNameShort), weekdays.map(function (date, idx) {
    var _a;

    return React.createElement("div", {
      key: idx,
      className: classnames(styles$5.dayHeader, (_a = {}, _a[styles$5.active] = isMobile && date.equals(calendarViewStartsAt), _a)),
      onClick: function onClick() {
        return onWeekdaySelected(date);
      }
    }, React.createElement("div", {
      className: styles$5.weekday
    }, date.toFormat('EEE').toUpperCase()), React.createElement("div", {
      className: styles$5.date
    }, date.toFormat('MMM d')));
  }));
};

var CalendarContext = createContext(null);
var MINUTES_IN_DAY$1 = 1440;

var Calendar = function Calendar(_a) {
  var startDate = _a.startDate,
      endDate = _a.endDate,
      onTimeSlotSelected = _a.onTimeSlotSelected,
      timeIntervalInMinutes = _a.timeIntervalInMinutes,
      _b = _a.rowHeight,
      rowHeight = _b === void 0 ? 40 : _b,
      children = _a.children,
      _c = _a.isMobile,
      isMobile = _c === void 0 ? false : _c,
      minColSize = _a.minColSize,
      className = _a.className;
  /**
   * Mange vertical scroll positiion
   * When component re-renders set scroll position back to previous state
   * */

  var _d = useState(0),
      scrollPosition = _d[0],
      setScrollPosition = _d[1];

  var calendarVerticalScrollRef = useRef(null);
  var debouncedSetScrollPosition = useRef(debounce(function () {
    return calendarVerticalScrollRef.current && setScrollPosition(calendarVerticalScrollRef.current.scrollTop);
  }, 100, {
    trailing: true
  }));
  useLayoutEffect(function () {
    calendarVerticalScrollRef.current && calendarVerticalScrollRef.current.scrollTo(scrollPosition, 0);
  }, []);
  /**
   * Format start and end date to beginning and end of day respectively
   * This is important for checking distance between TimeBlock and edge of calendar to get grid column and row placement
   */

  var toEndOfDay = function toEndOfDay(date) {
    return date.set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999
    });
  };

  var startDateTime = startDate.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  });
  var endDateTime = toEndOfDay(endDate);
  /**
   * State for managing which calendar days to show. This is usually either a full week (Mon - Sun) or a single day (12:00AM - 12:59PM)
   * When the calendar start/end dates change, we need to update state so that the context provider gets updates values
   * New data objects are created on every render so we need to check that the actual date time changed
   */

  useEffect(function () {
    setCalendarViewStartsAt(startDateTime);
    setCalendarViewEndsAt(isMobile ? toEndOfDay(startDateTime) : endDateTime);
  }, [startDateTime.toMillis(), endDateTime.toMillis()]);

  var _e = useState(startDateTime),
      calendarViewStartsAt = _e[0],
      setCalendarViewStartsAt = _e[1];

  var _f = useState(isMobile ? toEndOfDay(startDateTime) : endDateTime),
      calendarViewEndsAt = _f[0],
      setCalendarViewEndsAt = _f[1];
  /**
   * Dates to show in header
   * e.g. [mon, tue, wed, ...]
   */


  var weekdays = getDateRangeInclusive(startDateTime, endDateTime);
  /**
   * Dates to show in calendar
   */

  var calendarDays = getDateRangeInclusive(calendarViewStartsAt, calendarViewEndsAt);
  /**
   * range of minutes from 0 to 1440 skipping by supplied interval
   * e.g. if timeIntervalInMinutes = 30 => [0,30,60,90,120,...]
   */

  var minuteTimelineIntervals = range(0, MINUTES_IN_DAY$1, timeIntervalInMinutes);
  /**
   * Time slots ro represent every box in calendar. This includes grid position and time
   * e.g. [{row, column, startTime, endTime}, {}, ...]
   */

  var timeSlots = getTimeSlots(timeIntervalInMinutes, calendarDays);
  /**
   * If isMobile changes, reset the calendar view to appropriate default size
   */

  useEffect(function () {
    setCalendarViewStartsAt(startDateTime);
    setCalendarViewEndsAt(isMobile ? toEndOfDay(startDateTime) : endDateTime);
  }, [isMobile]);
  return React.createElement("div", {
    className: classnames(styles$4.wrapper, className)
  }, React.createElement("div", {
    className: styles$4.scrollable
  }, React.createElement(WeekdayHeader, {
    weekdays: weekdays,
    calendarViewStartsAt: calendarViewStartsAt,
    isMobile: isMobile,
    onWeekdaySelected: function onWeekdaySelected(date) {
      if (isMobile) {
        setCalendarViewStartsAt(date);
        setCalendarViewEndsAt(toEndOfDay(date));
      }
    }
  }), React.createElement("div", {
    className: styles$4.calendarWrapper,
    onScroll: function onScroll() {
      return debouncedSetScrollPosition.current();
    },
    ref: calendarVerticalScrollRef
  }, React.createElement("div", {
    className: styles$4.calendar,
    style: {
      gridTemplateColumns: "40px repeat(" + calendarDays.length + ", minmax(" + (minColSize ? minColSize + 'px' : 'auto') + ", 1fr))",
      gridTemplateRows: "repeat(" + minuteTimelineIntervals.length + ", " + rowHeight + "px)"
    }
  }, minuteTimelineIntervals.map(function (minuteInterval, idx) {
    return React.createElement("div", {
      key: idx,
      className: styles$4.hour
    }, minuteInterval % 60 === 0 && calendarViewStartsAt.set({
      hour: minuteInterval / 60
    }).toFormat('h a'));
  }), timeSlots.map(function (_a, idx) {
    var _b;

    var row = _a.row,
        column = _a.column,
        startTime = _a.startTime,
        endTime = _a.endTime;
    return React.createElement("div", {
      key: idx,
      style: {
        gridColumn: column + 1,
        gridRow: row
      },
      onClick: function onClick() {
        return onTimeSlotSelected && onTimeSlotSelected({
          startTime: startTime,
          endTime: endTime
        });
      },
      className: classnames(styles$4.cell, (_b = {}, _b[styles$4.clickable] = !!onTimeSlotSelected, _b))
    });
  }), React.createElement(CalendarContext.Provider, {
    value: {
      calendarViewStartsAt: calendarViewStartsAt,
      calendarViewEndsAt: calendarViewEndsAt,
      timeIntervalInMinutes: timeIntervalInMinutes
    }
  }, children)))));
};

var styles$6 = {"timeBlock":"styles_timeBlock__257s4"};

var TimeBlock = function TimeBlock(_a) {
  var timeBlockStartsAt = _a.timeBlockStartsAt,
      timeBlockEndsAt = _a.timeBlockEndsAt,
      children = _a.children;
  var calendarContext = useContext(CalendarContext);

  if (!calendarContext) {
    throw new Error("TimeBlock components cannot be rendered outside the Calendar component");
  }

  var calendarViewStartsAt = calendarContext.calendarViewStartsAt,
      calendarViewEndsAt = calendarContext.calendarViewEndsAt,
      timeIntervalInMinutes = calendarContext.timeIntervalInMinutes; // Do not render the TimeBlock if it falls outside the current calendar view
  // add 1000 since the timeBlockEndsAt is exclusive end but calendarViewEndsAt is inclusive

  if (timeBlockStartsAt.toMillis() < calendarViewStartsAt.toMillis() || timeBlockEndsAt.toMillis() > calendarViewEndsAt.toMillis() + 1000) {
    return null;
  }
  /**
   * Intervals betwwen to get to `timeBlockStartsAt`
   * grid index starts at 1 so add +1 for correct placement
   */


  var rowStart = Math.round((timeBlockStartsAt.hour * 60 + timeBlockStartsAt.minute) / timeIntervalInMinutes) + 1;
  /**
   * # of days since beginning of calendar range
   * grid index starts at 1 and timeline is first column so add 2 for correct placement
   */

  var columnStart = Math.floor(timeBlockStartsAt.diff(calendarViewStartsAt, 'days').days + 2);
  /**
   * Number of intervals the time block should span
   * calculated as the number of itnervals betwwen time block start and end
   */

  var rowSpan = Math.round(timeBlockEndsAt.diff(timeBlockStartsAt, 'minutes').minutes / timeIntervalInMinutes);
  return React.createElement("div", {
    className: styles$6.timeBlock,
    style: {
      gridRow: rowStart + " / span " + rowSpan,
      gridColumn: columnStart + " / span 1"
    }
  }, children);
};

var styles$7 = {"date-change":"styles_date-change__3iHgU flex","range":"styles_range__2hhNh flex items-center justify-center p1","range-button":"styles_range-button__1FR7F styles_range__2hhNh flex items-center justify-center p1","dateChange":"styles_date-change__3iHgU flex","rangeButton":"styles_range-button__1FR7F styles_range__2hhNh flex items-center justify-center p1"};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CalendarIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2-2h24v24H-2z"
  }), React.createElement("path", {
    d: "M3 3h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm11-2v4M6 1v4M1 9h18",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
});

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var SmallRightIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "10",
    viewBox: "0 0 6 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-9-7h24v24H-9z"
  }), React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1 1l4 4-4 4"
  })));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var SmallLeftIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "10",
    viewBox: "0 0 6 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-9-7h24v24H-9z"
  }), React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 9L1 5l4-4"
  })));
});

var DatePaginator = function DatePaginator(_a) {
  var onNextRequested = _a.onNextRequested,
      onPreviousRequested = _a.onPreviousRequested,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$7.dateChange, className)
  }, React.createElement("button", {
    className: styles$7.rangeButton,
    onClick: onPreviousRequested
  }, React.createElement(SmallLeftIcon, null)), React.createElement("div", {
    className: styles$7.range
  }, React.createElement(CalendarIcon, null)), React.createElement("button", {
    className: styles$7.rangeButton,
    onClick: onNextRequested
  }, React.createElement(SmallRightIcon, null)));
};

var styles$8 = {"date":"styles_date__3wm54 flex items-center","year":"styles_year__1Vdmy ml2"};

var FormattedDateRange = function FormattedDateRange(_a) {
  var rangeStart = _a.rangeStart,
      rangeEnd = _a.rangeEnd,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$8.date, className)
  }, React.createElement("strong", null, rangeStart.toFormat('LLLL d'), " - ", rangeEnd.toFormat('LLLL d')), React.createElement("div", {
    className: styles$8.year
  }, rangeStart.toFormat('y')));
};

var styles$9 = {"card":"styles_card__1Qd8e","accent-one":"styles_accent-one__2CXu6","accent-two":"styles_accent-two__20Ykb","accent-three":"styles_accent-three__3d5e8","accent-four":"styles_accent-four__xeTQv","accent-five":"styles_accent-five__24i86","accent-six":"styles_accent-six__3ngzt","accent-seven":"styles_accent-seven__2jvun","accent-eight":"styles_accent-eight__Xx3o8","accent-nine":"styles_accent-nine__wFxpO","accentOne":"styles_accent-one__2CXu6","accentTwo":"styles_accent-two__20Ykb","accentThree":"styles_accent-three__3d5e8","accentFour":"styles_accent-four__xeTQv","accentFive":"styles_accent-five__24i86","accentSix":"styles_accent-six__3ngzt","accentSeven":"styles_accent-seven__2jvun","accentEight":"styles_accent-eight__Xx3o8","accentNine":"styles_accent-nine__wFxpO"};

// We will apply one of these classes if if "accentHash" is provided

var CLASS_PREFIX$1 = 'accent-';
var PALETTE$1 = Object.keys(styles$9).filter(function (key) {
  return key.slice(0, CLASS_PREFIX$1.length) === CLASS_PREFIX$1;
}).map(function (className) {
  return styles$9[className];
});

var Card = function Card(_a) {
  var accent = _a.accent,
      accentHash = _a.accentHash,
      className = _a.className,
      children = _a.children,
      style = _a.style; // Choose an accent color for this card
  // For numeric values, use modulo to ensure incrementing numbers produce discrete colors

  var accentIndex;

  if (typeof accentHash === 'number') {
    accentIndex = accentHash % PALETTE$1.length;
  } else if (accentHash) {
    accentIndex = hashIndex(accentHash, PALETTE$1.length - 1);
  }

  var accentClassName = accentIndex !== undefined && PALETTE$1[accentIndex];
  return React.createElement("div", {
    className: classnames(className, accentClassName, styles$9.card),
    style: __assign({
      boxShadow: accent && "inset 0 2px " + accent
    }, style)
  }, children);
};

var styles$a = {"wrapper":"styles_wrapper__1eXnU items-center","disabled":"styles_disabled__39uhX","input":"styles_input__21Dwb","checkbox":"styles_checkbox__nWaMC mr1","label":"styles_label__2Jvgr","xsmall":"styles_xsmall__VWa-i","small":"styles_small__28aNV","medium":"styles_medium__cd4AT","large":"styles_large__2yFCv","xlarge":"styles_xlarge__ipRx2"};

// All other props are applied to the hidden `input`.

var Checkbox = function Checkbox(_a) {
  var _b;

  var _c = _a.height,
      height = _c === void 0 ? 'medium' : _c,
      className = _a.className,
      children = _a.children,
      disabled = _a.disabled,
      rest = __rest(_a, ["height", "className", "children", "disabled"]);

  var classes = classnames(styles$a.wrapper, styles$a[height], className, (_b = {}, _b[styles$a.disabled] = disabled, _b));
  return React.createElement("label", {
    className: classes
  }, React.createElement("input", __assign({
    type: "checkbox",
    className: styles$a.input,
    disabled: disabled
  }, rest)), React.createElement("span", {
    className: styles$a.checkbox
  }), React.createElement("span", {
    className: styles$a.label
  }, children));
};

var cssVars = {"breakpoint-xs":"360px","breakpoint-sm":"768px","breakpoint-md":"960px","breakpoint-lg":"1200px","breakpoint-xlg":"1440px","breakpoint-xxlg":"1600px","default-columns":"2","columns-sm":"8","columns-md":"12","breakpointXs":"360px","breakpointSm":"768px","breakpointMd":"960px","breakpointLg":"1200px","breakpointXlg":"1440px","breakpointXxlg":"1600px","defaultColumns":"2","columnsSm":"8","columnsMd":"12"};

var useBreakpoint = function useBreakpoint(breakpointName, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _a = useState(defaultMatches),
      matches = _a[0],
      setMatches = _a[1];

  useEffect(function () {
    var breakpointSize = cssVars["breakpoint-" + breakpointName.toLowerCase()];
    var mediaQueryFeature = "(min-width: " + breakpointSize + ")";
    var mediaQueryList = window.matchMedia(mediaQueryFeature);

    var listener = function listener() {
      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      return mediaQueryList.removeListener(listener);
    };
  }, [breakpointName]);
  return matches;
};

var styles$b = {"spinner":"styles_spinner__1L4nF flex flex-auto items-center justify-center","bounce":"styles_bounce__r0rIa inline-block","one":"styles_one__2dxRp styles_bounce__r0rIa inline-block","two":"styles_two__8DYP2 styles_bounce__r0rIa inline-block","three":"styles_three__12Qhn styles_bounce__r0rIa inline-block"};

var BubbleLoader = function BubbleLoader(_a) {
  var className = _a.className,
      color = _a.color,
      rest = __rest(_a, ["className", "color"]);

  var dotStyle = {
    backgroundColor: color
  };
  return React.createElement("div", __assign({
    className: classnames(styles$b.spinner, className)
  }, rest), React.createElement("div", {
    className: styles$b.one,
    style: dotStyle
  }), React.createElement("div", {
    className: styles$b.two,
    style: dotStyle
  }), React.createElement("div", {
    className: styles$b.three,
    style: dotStyle
  }));
};

var styles$c = {"loader":"styles_loader__3AMDb relative inline-block","inner":"styles_inner__1s069 absolute top-0 right-0 bottom-0 left-0","spinner-clip":"styles_spinner-clip__3Ijvg","circle":"styles_circle__1P6Fl absolute top-0 right-0 bottom-0 left-0","spinner-cycle":"styles_spinner-cycle__3sLYB","spinnerClip":"styles_spinner-clip__3Ijvg","spinnerCycle":"styles_spinner-cycle__3sLYB"};

function CircleLoader(_a) {
  var className = _a.className,
      _b = _a.color,
      color = _b === void 0 ? '#f55700' : _b,
      _c = _a.size,
      size = _c === void 0 ? '20px' : _c,
      _d = _a.thickness,
      thickness = _d === void 0 ? '0.1em' : _d;
  var spinnerClasses = classnames(styles$c.loader, className);
  var boxShadow = "inset 0 0 0 " + thickness + " " + color;
  return React.createElement("span", {
    className: spinnerClasses,
    style: {
      fontSize: size
    }
  }, React.createElement("i", {
    className: styles$c.inner
  }, React.createElement("span", {
    className: styles$c.circle,
    style: {
      boxShadow: boxShadow
    }
  })));
}

var styles$d = {"wrapper":"styles_wrapper__2y8E7","loader":"styles_loader__MlXOX mx-auto"};

var FullBlockLoader = function FullBlockLoader(_a) {
  var className = _a.className,
      Loader = _a.loader;
  return React.createElement("div", {
    className: styles$d.wrapper
  }, React.createElement("div", {
    className: styles$d.loader
  }, React.createElement(Loader, {
    className: className
  })));
};

var styles$e = {"wrapper":"styles_wrapper__2o8dC fixed top-0 right-0 bottom-0 left-0","loaderWrapper":"styles_loaderWrapper__KoKPH relative center"};

function FullPageLoader(_a) {
  var wrapperClassName = _a.wrapperClassName,
      className = _a.className,
      _b = _a.loader,
      Loader = _b === void 0 ? CircleLoader : _b;
  return React.createElement("section", {
    className: classnames(styles$e.wrapper, wrapperClassName)
  }, React.createElement("div", {
    className: styles$e.loaderWrapper
  }, React.createElement(Loader, {
    className: className
  })));
}

var styles$f = {"reloader":"styles_reloader__2r9pU fixed top-0 left-0","exited":"styles_exited__35OR3","entering":"styles_entering__3fk6V","entered":"styles_entered__3kcSt","exiting":"styles_exiting__3TAUD"};

var GlobalLoader = function GlobalLoader(_a) {
  var loading = _a.loading;
  return React.createElement(Transition, {
    in: loading,
    timeout: {
      enter: 2000,
      exit: 1000
    }
  }, function (state) {
    return React.createElement("div", {
      className: classnames(styles$f.reloader, styles$f[state])
    });
  });
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ErrorIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-7-7h24v24H-7z"
  }), React.createElement("path", {
    d: "M9 1L1 9m8 0L1 1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
});

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ValidIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "10",
    viewBox: "0 0 14 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-5-7h24v24H-5z"
  }), React.createElement("path", {
    d: "M1 5l4 4 8-8"
  })));
});

var styles$g = {"breakpoint-sm":"(min-width: 768px)","field":"styles_field__3zKTz flex flex-column","inputContainer":"styles_inputContainer__1QQOm relative flex flex-column","innerInputContainer":"styles_innerInputContainer__2_Vmz flex flex-auto","fieldContainer":"styles_fieldContainer__19hAc relative flex-auto","unit":"styles_unit__3oOYW flex","prependUnit":"styles_prependUnit__1qumj flex","label":"styles_label__3d47w absolute bottom-0","input":"styles_input__18X13 absolute bottom-0","withIcon":"styles_withIcon__3TZlY","errorText":"styles_errorText__2DmYX mt1","helpText":"styles_helpText__ZKp3e mt1","icon":"styles_icon__3sqkt absolute","errorIcon":"styles_errorIcon__5TVGI styles_icon__3sqkt absolute","validIcon":"styles_validIcon__2zj_T styles_icon__3sqkt absolute","loadingIcon":"styles_loadingIcon__3-WWv styles_icon__3sqkt absolute","additionalIcon":"styles_additionalIcon__XFN2Y styles_icon__3sqkt absolute","isValid":"styles_isValid__2-k0i","hasFocus":"styles_hasFocus__2LmFD","hasValue":"styles_hasValue__2qOph","hasError":"styles_hasError__15mhW","isLoading":"styles_isLoading__-g40c","isDisabled":"styles_isDisabled__3PTEL","isLabelHidden":"styles_isLabelHidden__1QBSr","standard":"styles_standard__2To-1","withUnit":"styles_withUnit__2EmuL","withError":"styles_withError__1J-No","xsmall":"styles_xsmall__2AncP","small":"styles_small__172l9","medium":"styles_medium__2Tl_N","large":"styles_large__BAMHE","xlarge":"styles_xlarge__nyNzF","breakpointSm":"(min-width: 768px)"};

var ResponsiveTextField =
/** @class */
function (_super) {
  __extends(ResponsiveTextField, _super);

  function ResponsiveTextField(props) {
    var _this = _super.call(this, props) || this;

    _this.checkPropInvariants(_this.props);

    _this.state = {
      // Autofocus will always exist via `defaultProps`
      hasFocus: _this.props.autoFocus
    };
    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    return _this;
  }
  /**
   * Generate consistent ID for this input based on the props received:
   *  - Used to ensure the label and input are properly associated.
   *  - Must be consistent across server and browser renders.
   *  - Only used if an explicit `id` prop is not passed.
   */


  ResponsiveTextField.prototype.generateId = function () {
    return 'text-field-' + hash(this.props, {
      ignoreUnknown: true
    }).substr(0, 8);
  };

  ResponsiveTextField.prototype.componentDidUpdate = function (prevProps) {
    var id = this.props.id || this.generateId(); // Controlled focus => uncontrolled focus isn't allowed

    if (!isUndefined(prevProps.focused) && isUndefined(this.props.focused)) {
      console.warn("TextField (" + id + ") is changing from controlled focus to uncontrolled focus. TextFields should not switch from controlled to uncontrolled (or vice versa).");
    } // Uncontrolled focus => controlled focus isn't allowed


    if (isUndefined(prevProps.focused) && !isUndefined(this.props.focused)) {
      console.warn("TextField (" + id + ") is changing from uncontrolled focus to controlled focus. TextFields should not switch from uncontrolled to controlled (or vice versa).");
    } // Warn about "valid" and "errorText" conflicts, but only if they've changed meaningfully
    //   i.e. only if one of those props was previously "false"


    if (this.props.errorText && this.props.valid && (!prevProps.errorText || !prevProps.valid)) {
      this.checkPropInvariants(this.props);
    }
  };

  ResponsiveTextField.prototype.checkPropInvariants = function (props) {
    var id = props.id || this.generateId();

    if (props.valid && props.errorText) {
      console.warn("TextField (" + id + ") received both \"errorText\" and \"valid\" props. The error state will take precedence.");
    }
  };

  ResponsiveTextField.prototype.handleInputFocus = function (e) {
    // Only manage the input focus if the focus is not controlled by props
    if (isUndefined(this.props.focused)) {
      this.setState({
        hasFocus: true
      });
    }

    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  };

  ResponsiveTextField.prototype.handleInputBlur = function (e) {
    // Only manage the input focus if the focus is not controlled by props
    if (isUndefined(this.props.focused)) {
      this.setState({
        hasFocus: false
      });
    }

    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  };

  ResponsiveTextField.prototype.handleInputChange = function (e) {
    // Only manage the input value if the value is not controlled by props
    if (isUndefined(this.props.value)) {
      this.setState({
        hasValue: !!(e.target.value && e.target.value.length > 0)
      });
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  ResponsiveTextField.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        Icon = _c.icon,
        testId = _c.testId,
        className = _c.className;
    var id = this.props.id || this.generateId();
    var hasValue = !!(this.props.value || this.props.defaultValue || this.state.hasValue || this.props.inputProps && this.props.inputProps.value);
    var hasFocus = !!(this.props.focused || this.state.hasFocus);
    var hasError = this.props.errorText !== undefined || this.props.error;
    var isValid = !!(this.props.valid && !hasError);
    var isLoading = !!this.props.loading;
    var isDisabled = !!this.props.disabled;
    var isLabelHidden = !!this.props.labelHidden;
    var hasUnit = !!this.props.unit;
    var hasPrependUnit = hasUnit && this.props.unit == '$';
    var display = this.props.display;
    return React.createElement("div", {
      className: classnames(styles$g.field, styles$g[this.props.size], (_a = {}, _a[styles$g.standard] = !this.props.isMobile && display === 'responsive' || display === 'standard', _a[styles$g.hasFocus] = hasFocus, _a[styles$g.hasValue] = hasValue, _a[styles$g.hasError] = hasError, _a[styles$g.isValid] = isValid, _a[styles$g.isLoading] = isLoading, _a[styles$g.isDisabled] = isDisabled, _a[styles$g.isLabelHidden] = isLabelHidden, _a), className)
    }, React.createElement("div", {
      className: styles$g.inputContainer
    }, this.props.label && !this.props.labelHidden && React.createElement("label", {
      id: 'label-' + id,
      htmlFor: id,
      className: styles$g.label
    }, this.props.label), React.createElement("div", {
      className: styles$g.innerInputContainer
    }, hasPrependUnit && React.createElement("div", {
      className: styles$g.prependUnit
    }, this.props.unit), React.createElement("div", {
      className: styles$g.fieldContainer
    }, Icon && React.createElement(Icon, {
      className: styles$g.additionalIcon
    }), React.createElement("input", __assign({
      "data-testid": testId,
      className: classnames(styles$g.input, this.props.inputProps && this.props.inputProps.className, (_b = {}, _b[styles$g.withUnit] = hasUnit, _b[styles$g.withIcon] = Icon, _b[styles$g.withError] = hasError, _b)),
      disabled: this.props.disabled,
      defaultValue: this.props.defaultValue,
      id: id,
      name: this.props.name,
      onBlur: this.handleInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      placeholder: this.props.placeholder || isLabelHidden && this.props.label || undefined,
      readOnly: this.props.readOnly,
      type: this.props.type,
      value: this.props.value
    }, omit(this.props.inputProps, 'className'), {
      ref: this.props.inputRef
    })), hasError && React.createElement(ErrorIcon, {
      className: styles$g.errorIcon
    }), isValid && React.createElement(ValidIcon, {
      className: styles$g.validIcon
    }), isLoading && React.createElement(CircleLoader, {
      color: "#087bcc",
      size: "16px",
      thickness: "2px",
      className: styles$g.loadingIcon
    })), hasUnit && !hasPrependUnit && React.createElement("div", {
      className: styles$g.unit
    }, this.props.unit))), this.props.errorText && React.createElement("div", {
      className: styles$g.errorText
    }, this.props.errorText), this.props.helpText && React.createElement("div", {
      className: styles$g.helpText
    }, this.props.helpText));
  };

  ResponsiveTextField.defaultProps = {
    autoFocus: false,
    display: 'responsive',
    size: 'medium'
  };
  return ResponsiveTextField;
}(React.PureComponent);

var TextField = React.forwardRef(function (props, ref) {
  var isMobile = !useBreakpoint('sm');
  return React.createElement(ResponsiveTextField, __assign({
    inputRef: ref,
    isMobile: isMobile
  }, props));
});

var MaskedField = function MaskedField(_a) {
  var maskedFieldProps = _a.maskedFieldProps,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      props = __rest(_a, ["maskedFieldProps", "onBlur", "onChange"]);

  return React.createElement(Masked, __assign({
    render: function render(ref, renderProps) {
      var passThroughRenderProps = omit(renderProps, 'defaultValue');
      return React.createElement(TextField, __assign({
        ref: ref
      }, props, passThroughRenderProps));
    },
    // These two handlers are wrapped by `react-text-mask` and passed back down to the
    //   underlying <TextField> via the `renderProps` above.
    onBlur: onBlur,
    onChange: onChange
  }, maskedFieldProps));
};

var numberMask = createNumberMask({
  prefix: '$',
  allowDecimal: true
});

var CurrencyField =
/** @class */
function (_super) {
  __extends(CurrencyField, _super);

  function CurrencyField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CurrencyField.prototype.render = function () {
    var _a = this.props,
        placeholder = _a.placeholder,
        maskedFieldProps = _a.maskedFieldProps,
        rest = __rest(_a, ["placeholder", "maskedFieldProps"]);

    return React.createElement(MaskedField, __assign({
      placeholder: placeholder,
      maskedFieldProps: __assign({
        mask: numberMask
      }, maskedFieldProps)
    }, rest));
  };

  CurrencyField.defaultProps = {
    placeholder: 'Enter amount',
    autoFocus: false
  };
  return CurrencyField;
}(React.Component);

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CalendarIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2-1h24v24H-2z"
  }), React.createElement("g", {
    stroke: "#9F9F9F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    transform: "translate(1 1)"
  }, React.createElement("path", {
    d: "M13 4V0M5 4V0M0 7h18"
  }), React.createElement("rect", {
    width: "18",
    height: "16",
    y: "2",
    rx: "1"
  }))));
});

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ErrorIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-7-7h24v24H-7z"
  }), React.createElement("path", {
    d: "M9 1L1 9m8 0L1 1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  })));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ValidIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "10",
    viewBox: "0 0 14 10"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-5-7h24v24H-5z"
  }), React.createElement("path", {
    d: "M1 5l4 4 8-8"
  })));
});

var styles$h = {"breakpoint-sm":"(min-width: 768px)","field":"styles_field__2brWV flex flex-column","inputContainer":"styles_inputContainer__1bctN relative flex flex-column","innerInputContainer":"styles_innerInputContainer__jxIOi flex flex-auto","dualField":"styles_dualField__oy0Ei flex","date":"styles_date__32gbV","time":"styles_time__1rS64","label":"styles_label__Fo8GL","hasError":"styles_hasError__1OqkT","datePicker":"styles_datePicker__3ANTb flex flex-auto","errorIcon":"styles_errorIcon__2gM1d","validIcon":"styles_validIcon__1_Bhg","errorText":"styles_errorText__1KuBx","jointErrorText":"styles_jointErrorText__1UV7B","helpText":"styles_helpText__25fhO","lowerText":"styles_lowerText__2ps5u","jointHelpText":"styles_jointHelpText__34cp0","closeWrapper":"styles_closeWrapper__eXz4f flex","openDown":"styles_openDown__2oxaI","openUp":"styles_openUp__2879L","isValid":"styles_isValid__1M99W","hasFocus":"styles_hasFocus__3weiG","multiMonth":"styles_multiMonth__1_kp4","breakpointSm":"(min-width: 768px)"};

var SingleDatePickerContainer = function SingleDatePickerContainer(_a) {
  var _b, _c, _d;

  var id = _a.id,
      date = _a.date,
      className = _a.className,
      label = _a.label,
      _e = _a.numberOfMonths,
      numberOfMonths = _e === void 0 ? 1 : _e,
      _f = _a.hideIcon,
      hideIcon = _f === void 0 ? true : _f,
      _g = _a.allowPreviousDates,
      allowPreviousDates = _g === void 0 ? false : _g,
      _h = _a.labelHidden,
      labelHidden = _h === void 0 ? false : _h,
      _onFocusChange = _a.onFocusChange,
      _j = _a.openDirection,
      openDirection = _j === void 0 ? 'down' : _j,
      _k = _a.error,
      error = _k === void 0 ? false : _k,
      withFullScreenPortal = _a.withFullScreenPortal,
      keepOpenOnDateSelect = _a.keepOpenOnDateSelect,
      _onDateChange = _a.onDateChange,
      _onClose = _a.onClose,
      errorText = _a.errorText,
      helpText = _a.helpText,
      valid = _a.valid,
      loading = _a.loading,
      disabled = _a.disabled,
      rest = __rest(_a, ["id", "date", "className", "label", "numberOfMonths", "hideIcon", "allowPreviousDates", "labelHidden", "onFocusChange", "openDirection", "error", "withFullScreenPortal", "keepOpenOnDateSelect", "onDateChange", "onClose", "errorText", "helpText", "valid", "loading", "disabled"]);

  var _l = useState(false),
      focused = _l[0],
      setFocused = _l[1];

  var _m = useState(!!date ? toMomentObject(new Date(date), 'LLLL') : null),
      selectedDate = _m[0],
      setSelectedDate = _m[1];

  var hasError = !!errorText || error;
  var hasHelpText = !!helpText;
  var isValid = valid && !hasError;
  var ComponentIcon = React.createElement(CalendarIcon$1, null);

  if (hasError) {
    ComponentIcon = React.createElement(ErrorIcon$1, {
      className: styles$h.errorIcon
    });
  } else if (isValid) {
    ComponentIcon = React.createElement(ValidIcon$1, {
      className: styles$h.validIcon
    });
  } else if (loading) {
    ComponentIcon = React.createElement(CircleLoader, {
      color: "#087bcc",
      size: "16px",
      thickness: "2px",
      className: styles$h.loadingIcon
    });
  }

  return React.createElement("div", {
    className: styles$h.field
  }, React.createElement("div", {
    className: styles$h.inputContainer
  }, !labelHidden && label && React.createElement("label", {
    id: "label-" + id,
    htmlFor: id,
    className: classnames(styles$h.label, (_b = {}, _b[styles$h.hasError] = hasError, _b))
  }, label), React.createElement("div", {
    className: styles$h.innerInputContainer
  }, React.createElement("div", {
    "data-testid": "single-date-picker",
    className: classnames(styles$h.datePicker, (_c = {}, _c[styles$h.openDown] = openDirection === 'down', _c[styles$h.openUp] = openDirection === 'up', _c[styles$h.multiMonth] = numberOfMonths > 1, _c[styles$h.hasFocus] = focused, _c[styles$h.hasError] = hasError, _c[styles$h.isValid] = isValid, _c), className)
  }, React.createElement(SingleDatePicker, __assign({
    id: id,
    readOnly: true,
    openDirection: openDirection,
    numberOfMonths: numberOfMonths,
    inputIconPosition: 'after',
    showDefaultInputIcon: !hideIcon,
    hideKeyboardShortcutsPanel: true,
    withFullScreenPortal: withFullScreenPortal,
    keepOpenOnDateSelect: withFullScreenPortal ? false : keepOpenOnDateSelect,
    customInputIcon: ComponentIcon,
    date: selectedDate,
    focused: focused,
    disabled: disabled,
    isOutsideRange: allowPreviousDates ? function () {
      return false;
    } : undefined,
    onDateChange: function onDateChange(date) {
      if (date) {
        setSelectedDate(date);
        var formattedDate = date.toDate();
        _onDateChange && _onDateChange(formattedDate);
      }
    },
    onFocusChange: function onFocusChange(_a) {
      var focused = _a.focused;
      setFocused(focused || false);
      _onFocusChange && _onFocusChange(focused);
    },
    onClose: function onClose(_a) {
      var startDate = _a.startDate,
          endDate = _a.endDate;
      _onClose && _onClose({
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
      });
    }
  }, rest)))), hasError && React.createElement("div", {
    className: styles$h.errorText
  }, errorText), hasHelpText && React.createElement("div", {
    className: classnames(styles$h.helpText, (_d = {}, _d[styles$h.lowerText] = !hasError, _d))
  }, helpText)));
};

var TimePicker = function TimePicker(_a) {
  var date = _a.date,
      onTimeChange = _a.onTimeChange,
      disabled = _a.disabled,
      error = _a.error,
      label = _a.label,
      timeZone = _a.timeZone,
      _b = _a.labelHidden,
      labelHidden = _b === void 0 ? false : _b,
      rest = __rest(_a, ["date", "onTimeChange", "disabled", "error", "label", "timeZone", "labelHidden"]);

  var handleTimeChange = function handleTimeChange(evt) {
    var hourAndMinute = evt.target.value.split(':');
    var hour = parseInt(hourAndMinute[0] || '12', 10);
    var minute = parseInt(hourAndMinute[1] || '00', 10);
    var timeZoneDate = date ? timeZone ? DateTime.fromJSDate(date).setZone(timeZone).set({
      hour: hour,
      minute: minute
    }) : DateTime.fromJSDate(date).set({
      hour: hour,
      minute: minute
    }) : undefined;

    if (timeZoneDate && onTimeChange) {
      onTimeChange(timeZoneDate.toJSDate());
    }
  };

  return React.createElement(TextField, __assign({
    inputProps: {
      type: 'time',
      maxLength: 10
    },
    label: label || '',
    labelHidden: labelHidden,
    disabled: disabled,
    value: date ? timeZone ? DateTime.fromJSDate(date).setZone(timeZone).toFormat('HH:mm') : format(date, 'HH:mm') : undefined,
    onChange: handleTimeChange,
    error: error
  }, rest));
};

var SingleDatePickerWithTime = function SingleDatePickerWithTime(_a) {
  var id = _a.id,
      label = _a.label,
      helpText = _a.helpText,
      valid = _a.valid,
      loading = _a.loading,
      disabled = _a.disabled,
      errorText = _a.errorText,
      labelHidden = _a.labelHidden,
      onDateTimeChange = _a.onDateTimeChange,
      startingDate = _a.startingDate,
      _b = _a.datePickerProps,
      datePickerProps = _b === void 0 ? {} : _b,
      _c = _a.timePickerProps,
      timePickerProps = _c === void 0 ? {} : _c;

  var _d = useState(startingDate ? new Date(startingDate) : new Date()),
      date = _d[0],
      setDate = _d[1];

  var _e = useState(startingDate ? new Date(startingDate) : new Date()),
      time = _e[0],
      setTime = _e[1];

  var handleDateTimeUpdate = function handleDateTimeUpdate() {
    var minutes = time.getMinutes();
    var hours = time.getHours();
    return setMinutes(setHours(date, hours), minutes);
  };

  useEffect(function () {
    onDateTimeChange(handleDateTimeUpdate());
  }, [time, date]);
  var hasError = !!errorText;
  var hasHelpText = !!helpText;
  var isValid = valid && !hasError;
  return React.createElement("div", {
    className: styles$h.field
  }, React.createElement("div", {
    className: styles$h.inputContainer
  }, !labelHidden && label && React.createElement("label", {
    id: "label-" + id,
    htmlFor: id,
    className: styles$h.label
  }, label), React.createElement("div", {
    className: styles$h.dualField
  }, React.createElement("div", {
    className: styles$h.date
  }, React.createElement(SingleDatePickerContainer, __assign({
    id: id + "-date",
    loading: loading,
    valid: isValid,
    date: date,
    error: hasError,
    disabled: disabled,
    onDateChange: function onDateChange(date) {
      return date && setDate(date);
    }
  }, datePickerProps))), React.createElement("div", {
    className: styles$h.time
  }, React.createElement(TimePicker, __assign({
    id: id + "-time",
    date: time,
    valid: isValid,
    error: hasError,
    loading: loading,
    disabled: disabled,
    onTimeChange: function onTimeChange(time) {
      return setTime(time);
    }
  }, timePickerProps)))), hasError && React.createElement("div", {
    className: styles$h.jointErrorText
  }, errorText), hasHelpText && React.createElement("div", {
    className: styles$h.jointHelpText
  }, helpText)));
};

var DatePicker = function DatePicker(_a) {
  var _b, _c;

  var id = _a.id,
      label = _a.label,
      _d = _a.allowPreviousDates,
      allowPreviousDates = _d === void 0 ? false : _d,
      _e = _a.hideIcon,
      hideIcon = _e === void 0 ? true : _e,
      className = _a.className,
      selectedStartDate = _a.selectedStartDate,
      _f = _a.openDirection,
      openDirection = _f === void 0 ? 'down' : _f,
      selectedEndDate = _a.selectedEndDate,
      _g = _a.labelHidden,
      labelHidden = _g === void 0 ? false : _g,
      withFullScreenPortal = _a.withFullScreenPortal,
      keepOpenOnDateSelect = _a.keepOpenOnDateSelect,
      _onDatesChange = _a.onDatesChange,
      _h = _a.numberOfMonths,
      numberOfMonths = _h === void 0 ? 2 : _h,
      _onClose = _a.onClose,
      errorText = _a.errorText,
      helpText = _a.helpText,
      valid = _a.valid,
      loading = _a.loading,
      disabled = _a.disabled,
      rest = __rest(_a, ["id", "label", "allowPreviousDates", "hideIcon", "className", "selectedStartDate", "openDirection", "selectedEndDate", "labelHidden", "withFullScreenPortal", "keepOpenOnDateSelect", "onDatesChange", "numberOfMonths", "onClose", "errorText", "helpText", "valid", "loading", "disabled"]);

  var _j = useState(null),
      focusedDate = _j[0],
      setFocusedDate = _j[1];

  var _k = useState(!!selectedStartDate ? toMomentObject(new Date(selectedStartDate), 'LLLL') : null),
      startDate = _k[0],
      setStartDate = _k[1];

  var _l = useState(!!selectedEndDate ? toMomentObject(new Date(selectedEndDate), 'LLLL') : null),
      endDate = _l[0],
      setEndDate = _l[1];

  var hasError = errorText !== undefined;
  var hasHelpText = helpText !== undefined;
  var isValid = valid && !hasError;
  var ComponentIcon = React.createElement(CalendarIcon$1, null);

  if (hasError) {
    ComponentIcon = React.createElement(ErrorIcon$1, {
      className: styles$h.errorIcon
    });
  } else if (isValid) {
    ComponentIcon = React.createElement(ValidIcon$1, {
      className: styles$h.validIcon
    });
  } else if (loading) {
    ComponentIcon = React.createElement(CircleLoader, {
      color: "#087bcc",
      size: "16px",
      thickness: "2px",
      className: styles$h.loadingIcon
    });
  }

  return React.createElement("div", {
    className: styles$h.field
  }, React.createElement("div", {
    className: styles$h.inputContainer
  }, !labelHidden && label && React.createElement("label", {
    id: "label-" + id,
    htmlFor: id,
    className: styles$h.label
  }, label), React.createElement("div", {
    className: styles$h.innerInputContainer
  }, React.createElement("div", {
    "data-testid": "ranged-date-picker",
    className: classnames(styles$h.datePicker, (_b = {}, _b[styles$h.openDown] = openDirection === 'down', _b[styles$h.openUp] = openDirection === 'up', _b[styles$h.multiMonth] = numberOfMonths > 1, _b[styles$h.hasFocus] = focusedDate !== null, _b[styles$h.hasError] = errorText !== undefined, _b[styles$h.isValid] = isValid, _b), className)
  }, React.createElement(DateRangePicker, __assign({
    openDirection: openDirection,
    inputIconPosition: 'after',
    startDateId: "start-" + id,
    readOnly: true,
    endDateId: "end-" + id,
    showDefaultInputIcon: !hideIcon,
    keepOpenOnDateSelect: withFullScreenPortal ? false : keepOpenOnDateSelect,
    withFullScreenPortal: withFullScreenPortal,
    hideKeyboardShortcutsPanel: true,
    isOutsideRange: allowPreviousDates ? function () {
      return false;
    } : undefined,
    customInputIcon: ComponentIcon,
    startDate: startDate,
    endDate: endDate,
    disabled: disabled,
    onDatesChange: function onDatesChange(_a) {
      var startDate = _a.startDate,
          endDate = _a.endDate;

      var _b, _c;

      setStartDate(startDate);
      setEndDate(endDate);
      _onDatesChange && _onDatesChange({
        startDate: (_b = startDate) === null || _b === void 0 ? void 0 : _b.toDate(),
        endDate: (_c = endDate) === null || _c === void 0 ? void 0 : _c.toDate()
      });
    },
    numberOfMonths: numberOfMonths,
    focusedInput: focusedDate,
    onFocusChange: function onFocusChange(focusTarget) {
      setFocusedDate(focusTarget);
    },
    onClose: function onClose(_a) {
      var startDate = _a.startDate,
          endDate = _a.endDate;
      _onClose && _onClose({
        startDate: startDate.toDate(),
        endDate: endDate.toDate()
      });
    }
  }, rest)))), hasError && React.createElement("div", {
    className: styles$h.errorText
  }, errorText), hasHelpText && React.createElement("div", {
    className: classnames(styles$h.helpText, (_c = {}, _c[styles$h.lowerText] = !hasError, _c))
  }, helpText)));
};

var styles$i = {"wrapper":"styles_wrapper__1NFz6 items-center","disabled":"styles_disabled__3YlCV","input":"styles_input__KSJEj","radioButton":"styles_radioButton__1w0VL","label":"styles_label__1czvY inline-block","xsmall":"styles_xsmall__3XL_w","small":"styles_small__63F3m","medium":"styles_medium__SkWIU","large":"styles_large__2Bgc_","xlarge":"styles_xlarge__1lCzr"};

// All other props are applied to the hidden `input`.

var Radio = function Radio(_a) {
  var _b;

  var _c = _a.height,
      height = _c === void 0 ? 'medium' : _c,
      className = _a.className,
      disabled = _a.disabled,
      children = _a.children,
      labelClassName = _a.labelClassName,
      radioClassName = _a.radioClassName,
      rest = __rest(_a, ["height", "className", "disabled", "children", "labelClassName", "radioClassName"]);

  var classes = classnames(styles$i.wrapper, styles$i[height], className, (_b = {}, _b[styles$i.disabled] = disabled, _b));
  return React.createElement("label", {
    className: classes
  }, React.createElement("input", __assign({
    disabled: disabled,
    type: "radio",
    className: styles$i.input
  }, rest)), React.createElement("span", {
    className: classnames(styles$i.radioButton, radioClassName)
  }), React.createElement("span", {
    className: classnames(styles$i.label, labelClassName)
  }, children));
};

var styles$j = {"icon":"styles_icon__2RUgq"};

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var beer = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M15 6h-1.3c.2-.3.3-.6.3-1 0-1.1-.9-2-2-2-.4 0-.8.1-1.1.3C10.6 1.4 9 0 7 0S3.4 1.4 3.1 3.3C2.8 3.1 2.4 3 2 3 .9 3 0 3.9 0 5c0 .7.4 1.4 1 1.7V15c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-3h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zm-4 8H3V7h2v2.5c0 .8.7 1.5 1.5 1.5S8 10.3 8 9.5V7h3v7zm3-4h-1V8h1v2z"
  }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var cake = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 6c1.1 0 2-.9 2-2S8 0 8 0 6 2.9 6 4s.9 2 2 2zm7 5h-1V8c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v3H1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1z"
  }));
});

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var charters = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15"
  }, props), React.createElement("path", {
    d: "M16 15h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01A5.55 5.55 0 0 1 1 15H0v-2h1a3.525 3.525 0 0 0 2.735-1.277l.764-.91.766.909a3.566 3.566 0 0 0 5.462.01l.773-.943.773.943A3.5 3.5 0 0 0 15 13h1v2zm0-5h-1a5.534 5.534 0 0 1-3.5-1.229 5.581 5.581 0 0 1-7-.01A5.55 5.55 0 0 1 1 10H0V8h1a3.525 3.525 0 0 0 2.735-1.277l.764-.91.766.909a3.566 3.566 0 0 0 5.462.01l.773-.943.773.943A3.5 3.5 0 0 0 15 8h1v2zm0-5h-1a5.534 5.534 0 0 1-3.5-1.229A5.534 5.534 0 0 1 8 5a5.556 5.556 0 0 1-3.5-1.239A5.55 5.55 0 0 1 1 5H0V3h1a3.525 3.525 0 0 0 2.735-1.277L4.5.813l.766.909A3.525 3.525 0 0 0 8 3a3.5 3.5 0 0 0 2.727-1.268L11.5.789l.773.943A3.5 3.5 0 0 0 15 3h1v2z"
  }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var chat = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M6.5 0C2.91 0 0 2.462 0 5.5c0 1.075.37 2.074 1 2.922V12l2.699-1.542A7.454 7.454 0 0 0 6.5 11c3.59 0 6.5-2.462 6.5-5.5S10.09 0 6.5 0z"
  }), React.createElement("path", {
    d: "M16 9.5c0-.987-.429-1.897-1.147-2.639C14.124 10.348 10.66 13 6.5 13c-.103 0-.202-.018-.305-.021C7.231 13.617 8.556 14 10 14c.449 0 .886-.04 1.307-.11L15 16v-4h-.012C15.627 11.285 16 10.425 16 9.5z"
  }));
});

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var check = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"
  }));
});

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var cocktail = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M16 5.5C16 3.6 14.4 2 12.5 2c-1.8 0-3.2 1.3-3.4 3H6L5 .8C4.9.3 4.5 0 4 0H1C.4 0 0 .4 0 1s.4 1 1 1h2.2L4 5H1v9c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V8.9c1.7-.2 3-1.6 3-3.4z"
  }));
});

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var cycling = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M12.809 9.031L10.976.783A1 1 0 0 0 10 0H6v2h3.2l.774 3.484-5.5 3.67A3.451 3.451 0 0 0 3.5 9 3.5 3.5 0 1 0 7 12.5a3.465 3.465 0 0 0-.746-2.134l4.183-2.789.412 1.856a3.5 3.5 0 1 0 1.959-.4l.001-.002zM3.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  }), React.createElement("path", {
    d: "M4.581 6.674l1.664-1.109-1.413-2.12A1 1 0 0 0 4 3H1v2h2.465l1.116 1.674z"
  }));
});

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var diploma = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M13 16H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h12v2H2v12h10v-1h2v2c0 .6-.4 1-1 1z"
  }), React.createElement("path", {
    d: "M16 6c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .9.4 1.7 1 2.2V12l2-2 2 2V8.2c.6-.5 1-1.3 1-2.2zM4 5h4v2H4zm0 4h5v2H4z"
  }));
});

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var drink = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16"
  }, props), React.createElement("path", {
    d: "M13.732.318A1 1 0 0 0 13 0H1a1 1 0 0 0-1 1.071l.934 13.072a2.007 2.007 0 0 0 2 1.857h8.138a2.007 2.007 0 0 0 1.995-1.857L14 1.071a1 1 0 0 0-.268-.753zM11.926 2L11.5 8h-9l-.426-6h9.852z"
  }));
});

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var golfClub = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "14",
    viewBox: "0 0 12 14"
  }, props), React.createElement("path", {
    d: "M8.038.534L1.372 4.238A2.667 2.667 0 0 0 0 6.569V14h2V9h7.333A2.667 2.667 0 0 0 12 6.333V2.865C12 .832 9.816-.453 8.038.535z"
  }));
});

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var golfCourse = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16"
  }, props), React.createElement("path", {
    d: "M2 14h12v2H2z"
  }), React.createElement("circle", {
    cx: "10.5",
    cy: "10.5",
    r: "2.5"
  }), React.createElement("path", {
    d: "M7 10.5a3.5 3.5 0 0 1 6.367-2l.165-1.156a3 3 0 0 0-3.918-3.27L3.571 6.089 1.958.713a1 1 0 1 0-1.916.574l2.786 9.287A1.988 1.988 0 0 0 4.744 12H7.35A3.464 3.464 0 0 1 7 10.5z"
  }));
});

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var jewelry = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "15",
    viewBox: "0 0 16 15"
  }, props), React.createElement("path", {
    d: "M2.211.686L2.2.706.167 3.956h3.308zM4.53 3.45L7.429.091H3.231l.007.018L4.53 3.45zM12.762.109l.007-.018H8.572l2.897 3.36L12.762.108zm3.071 3.846L13.8.707l-.012-.02-1.266 3.268zM11 5.172L8 8.924 5 5.172H.086L7.23 13.71l.4.478a.486.486 0 0 0 .37.172.485.485 0 0 0 .368-.172l.4-.479 7.146-8.538H11z"
  }), React.createElement("path", {
    d: "M8 6.96l2.366-3.005L8 1.212 5.634 3.955z"
  }));
});

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var heart = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "14",
    viewBox: "0 0 16 14"
  }, props), React.createElement("path", {
    d: "M14.682 1.318a4.5 4.5 0 0 0-6.364 0c-.121.121-.214.259-.318.389-.104-.13-.197-.268-.318-.389a4.5 4.5 0 0 0-6.364 6.364L8 14l6.682-6.318a4.5 4.5 0 0 0 0-6.364z"
  }));
});

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$l(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var location = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$l(_ref, ["styles"]);

  return React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16"
  }, props), React.createElement("path", {
    d: "M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }));
});

var _extends$m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$m(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var mountain = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$m(_ref, ["styles"]);

  return React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "12",
    viewBox: "0 0 16 12"
  }, props), React.createElement("path", {
    d: "M4.496 3.423L3.5 2 0 7h2zM16 7l-3.5-5-1.01 1.442L13.892 7zm-4.676-2.014L8 0 4.666 5l6.658-.014zM3.995 6.007L0 12h16l-3.999-5.998-8.006.005z"
  }));
});

var _extends$n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$n(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var star = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$n(_ref, ["styles"]);

  return React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.65 6.106l5.925.86-4.288 4.18 1.012 5.901L9 14.261l-5.299 2.786 1.012-5.901-4.288-4.18 5.925-.86L9 .737l2.65 5.369z"
  }));
});



var icons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    beer: beer,
    cake: cake,
    charters: charters,
    chat: chat,
    check: check,
    cocktail: cocktail,
    cycling: cycling,
    diploma: diploma,
    drink: drink,
    golfClub: golfClub,
    golfCourse: golfCourse,
    jewelry: jewelry,
    heart: heart,
    location: location,
    mountain: mountain,
    star: star
});

var ExpertProfileHighlightIcon = function ExpertProfileHighlightIcon(_a) {
  var glyph = _a.glyph,
      className = _a.className,
      rest = __rest(_a, ["glyph", "className"]);

  var classes = classnames(styles$j.icon, className);
  var exportName = camelCase(glyph);
  var Icon; // @ts-ignore typescript doesn't recognize the glob import

  Icon = icons[exportName] || check;
  return React.createElement(Icon, __assign({
    className: classes
  }, rest));
};

var _extends$o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$o(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CampingIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$o(_ref, ["styles"]);

  return React.createElement("svg", _extends$o({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("g", {
    fill: "none"
  }, React.createElement("path", {
    d: "M6 31H1V18c0-1.1.9-2 2-2h3M26 31h5V18c0-1.1-.9-2-2-2h-3M20 5V1h-8v4M26 31H6V9c0-2.2 1.8-4 4-4h12c2.2 0 4 1.8 4 4v22z"
  }), React.createElement("path", {
    d: "M26 16c0 2.2-1.8 4-4 4H10c-2.2 0-4-1.8-4-4M12 22v-4M20 22v-4"
  })));
});

var _extends$p = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$p(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedInternalIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$p(_ref, ["styles"]);

  return React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "28",
    viewBox: "0 0 28 28"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2-2h32v32H-2z"
  }), React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M2 2v24h24V2H2zM0 0h28v28H0V0z"
  }), React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.5 13.826c0-1.189.291-2.278.873-3.244a6.146 6.146 0 0 1 2.356-2.273 6.679 6.679 0 0 1 3.24-.809c.945 0 1.841.191 2.677.574.824.385 1.54.924 2.144 1.615l.331.38-2.142 1.847-.328-.367a3.642 3.642 0 0 0-1.195-.896 3.504 3.504 0 0 0-1.488-.315c-.995 0-1.806.327-2.456.987-.66.67-.985 1.488-.985 2.501 0 1.014.324 1.83.984 2.488.652.66 1.465.987 2.457.987.538 0 1.041-.109 1.513-.325a3.362 3.362 0 0 0 1.193-.901l.327-.39 2.128 1.849-.316.376a6.19 6.19 0 0 1-2.15 1.644 6.287 6.287 0 0 1-2.695.59 6.7 6.7 0 0 1-2.51-.476 6.353 6.353 0 0 1-2.061-1.31 6.157 6.157 0 0 1-1.386-2.014 6.207 6.207 0 0 1-.511-2.518z"
  })));
});

var _extends$q = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$q(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CyclingIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$q(_ref, ["styles"]);

  return React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "30",
    viewBox: "0 0 30 30"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "14"
  }), React.createElement("path", {
    d: "M1 15h12m4 0h12M15 29V17.002M15 13V1M5.1 24.9l8.4-8.4m3-3l8.4-8.4m0 19.8l-8.4-8.4m-2.992-2.992L5.1 5.1"
  })));
});

var _extends$r = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$r(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var GolfIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$r(_ref, ["styles"]);

  return React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "25",
    viewBox: "0 0 22 25"
  }, props), React.createElement("path", {
    d: "M12.5 8.5V16M8 11.5V16m6.75 3v5.25m-9 0V19M3.5 19H17m2.25-10.5H12.5V5.716a1.5 1.5 0 0 1 .879-1.366l5.25-2.386a1.5 1.5 0 0 1 2.121 1.365V7a1.5 1.5 0 0 1-1.5 1.5zm-16.5 3H8V9.475a1.5 1.5 0 0 0-.891-1.371l-3.75-1.667A1.5 1.5 0 0 0 1.25 7.808V10a1.5 1.5 0 0 0 1.5 1.5z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }));
});

var _extends$s = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$s(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var JetChartersIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$s(_ref, ["styles"]);

  return React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    d: "M1 26C4.947 9.618 25.9 15.456 31 3c1.984 9.908-.665 16.717-12 17m10-3c2 6.5-3 11.5-14 9.971",
    fill: "none",
    fillRule: "evenodd"
  }));
});

var _extends$t = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$t(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var JewelryIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$t(_ref, ["styles"]);

  return React.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "29",
    viewBox: "0 0 30 29"
  }, props), React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M15 27l5.5-17.5-5-8.5"
  }), React.createElement("path", {
    d: "M15.5 1l-5 8.5L15 27M6 1l4.5 8.5M24 1l-3.5 8.5M1.5 9.5h27"
  }), React.createElement("path", {
    d: "M29 9.5L15 28 1 9.5 6 1h18z"
  })));
});

var _extends$u = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$u(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var WinterSportsIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$u(_ref, ["styles"]);

  return React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "26",
    viewBox: "0 0 30 26"
  }, props), React.createElement("path", {
    d: "M11.563 7.345L8 2 1 14h6.958m10.479-6.655L22 2l7 12h-6.958M11.208 8h7.584M15 1l13 24H2z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }));
});

var _extends$v = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$v(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var YachtChartersIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$v(_ref, ["styles"]);

  return React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24",
    viewBox: "0 0 32 24"
  }, props), React.createElement("path", {
    d: "M1 23a9.731 9.731 0 0 0 7.5-3.5 9.786 9.786 0 0 0 15 0A9.676 9.676 0 0 0 31 23M1 14a9.731 9.731 0 0 0 7.5-3.5 9.786 9.786 0 0 0 15 0A9.676 9.676 0 0 0 31 14M1 5a9.731 9.731 0 0 0 7.5-3.5A9.737 9.737 0 0 0 16 5a9.676 9.676 0 0 0 7.5-3.5A9.676 9.676 0 0 0 31 5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    fillRule: "evenodd"
  }));
});

var styles$k = {"icon":"styles_icon__58Z3K"};

var DepartmentIcon = function DepartmentIcon(_a) {
  var departmentSlug = _a.departmentSlug,
      _b = _a.strokeWidth,
      strokeWidth = _b === void 0 ? 1 : _b,
      className = _a.className,
      rest = __rest(_a, ["departmentSlug", "strokeWidth", "className"]);

  var sharedProps = {
    className: classnames(styles$k.icon, className),
    strokeWidth: strokeWidth
  };

  switch (departmentSlug) {
    case 'golf':
      return React.createElement(GolfIcon, __assign({}, sharedProps, rest));

    case 'cycling':
      return React.createElement(CyclingIcon, __assign({}, sharedProps, rest));

    case 'jewelry':
      return React.createElement(JewelryIcon, __assign({}, sharedProps, rest));

    case 'winter-sports':
      return React.createElement(WinterSportsIcon, __assign({}, sharedProps, rest));

    case 'yacht-charters':
      return React.createElement(YachtChartersIcon, __assign({}, sharedProps, rest));

    case 'jet-charters':
      return React.createElement(JetChartersIcon, __assign({}, sharedProps, rest));

    case 'camping':
      return React.createElement(CampingIcon, __assign({}, sharedProps, rest));

    case 'curated-internal':
      return React.createElement(CuratedInternalIcon, __assign({
        className: className,
        strokeWidth: strokeWidth
      }, rest));

    default:
      throw new Error("Unrecognized department passed to DepartmentIcon component [" + departmentSlug + "]");
  }
};

var styles$l = {"container":"styles_container__2h3lF relative flex align-end","sizing-cover":"styles_sizing-cover__qucOn","image":"styles_image__36sKi absolute top-0 left-0 right-0 bottom-0","sizing-contain":"styles_sizing-contain__sJ-oq","aspect-ratio-wide":"styles_aspect-ratio-wide__2wDrX","aspect-ratio-tall":"styles_aspect-ratio-tall__xGGdu","aspect-ratio-square":"styles_aspect-ratio-square__SJU74","content":"styles_content__2vzgm absolute top-0 left-0 right-0 bottom-0","sizingCover":"styles_sizing-cover__qucOn","sizingContain":"styles_sizing-contain__sJ-oq","aspectRatioWide":"styles_aspect-ratio-wide__2wDrX","aspectRatioTall":"styles_aspect-ratio-tall__xGGdu","aspectRatioSquare":"styles_aspect-ratio-square__SJU74"};

var FixedAspectRatioImage = function FixedAspectRatioImage(_a) {
  var _b = _a.aspectRatio,
      aspectRatio = _b === void 0 ? 'square' : _b,
      _c = _a.sizing,
      sizing = _c === void 0 ? 'contain' : _c,
      className = _a.className,
      contentClassName = _a.contentClassName,
      children = _a.children,
      rest = __rest(_a, ["aspectRatio", "sizing", "className", "contentClassName", "children"]);

  var paddingBottom = typeof aspectRatio === 'number' ? 1 / aspectRatio * 100 + "%" : undefined;
  return React.createElement("div", {
    className: classnames(styles$l.container, styles$l["sizing-" + sizing], typeof aspectRatio === 'string' && styles$l["aspect-ratio-" + aspectRatio]),
    style: {
      paddingBottom: paddingBottom
    }
  }, React.createElement(Image, __assign({
    className: classnames(styles$l.image, className)
  }, rest)), React.createElement("div", {
    className: classnames(styles$l.content, contentClassName)
  }, children));
};

function deprecate(Component, message) {
  var logDeprecationWarning = once(function () {
    var displayName = Component.displayName || Component.name;

    if (process.env.NODE_ENV !== 'test') {
      console.warn(message || "The <" + displayName + " /> component is deprecated.");
    }
  });
  return function (props) {
    logDeprecationWarning();
    return React.createElement(Component, __assign({}, props));
  };
}

var styles$m = {"icon":"styles_icon__3am-1"};

var Icon = function Icon(_a) {
  var Glyph = _a.glyph,
      className = _a.className,
      rest = __rest(_a, ["glyph", "className"]);

  return React.createElement(Glyph, __assign({
    className: classnames(styles$m.icon, className)
  }, rest));
};

var index = deprecate(Icon, "The <Icon> component is deprecated. Use the imported SVG as a React component directly in JSX instead.");

var LazysizesSnippet = function LazysizesSnippet() {
  return React.createElement("script", {
    src: "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js",
    async: true
  });
};

var styles$n = {"footer":"styles_footer__2XYQk","fixed":"styles_fixed__dLcbs styles_footer__2XYQk fixed","sticky":"styles_sticky__3PdjY styles_footer__2XYQk absolute"};

var Footer =
/** @class */
function (_super) {
  __extends(Footer, _super);

  function Footer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    _this.handleResize = _this.handleResize.bind(_this);
    return _this;
  }

  Footer.prototype.handleResize = function (contentRect) {
    if (contentRect.bounds) {
      this.setState({
        height: contentRect.bounds.height
      });
    }
  };

  Footer.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        children = _a.children,
        position = _a.position,
        rest = __rest(_a, ["className", "children", "position"]);

    return React.createElement("div", {
      style: {
        height: this.state.height
      }
    }, React.createElement(Measure, {
      bounds: true,
      onResize: this.handleResize
    }, function (_a) {
      var measureRef = _a.measureRef;
      return React.createElement("footer", __assign({
        className: classnames(className, styles$n[position]),
        ref: measureRef
      }, rest), children);
    }));
  };

  return Footer;
}(PureComponent);
var FixedFooter = function FixedFooter(props) {
  return React.createElement(Footer, __assign({
    position: "fixed"
  }, props));
};
var StickyFooter = function StickyFooter(props) {
  return React.createElement(Footer, __assign({
    position: "sticky"
  }, props));
};

/**
 * Parse a grid area template into a matrix of strings
 */

function parseTemplate(template) {
  var sourceTemplateRowsMatch = template.match(/\"[^\"]+\"/g);

  if (!sourceTemplateRowsMatch) {
    throw new Error("Can not parse template " + template);
  }

  return sourceTemplateRowsMatch.map(function (row) {
    return row.slice(1, -1);
  }) // Remove the leading and trailing double quotes
  .map(function (row) {
    return row.trim();
  }) // Remove excess leading and trailing whitespace
  .map(function (row) {
    return row.split(/\s+/);
  }); // Tokenize by whitespace
}
/**
 * Trim excess whitespace from a grid area template
 */

function minifyTemplate(template) {
  var parsed = parseTemplate(template);
  return '"' + parsed.map(function (row) {
    return row.join(' ');
  }).join('" "') + '"';
}
/**
 * Calculate the number of columns in a given grid area template
 */

function columnCountFromTemplate(template) {
  var parsed = parseTemplate(template);
  return Math.max.apply(Math, parsed.map(function (row) {
    return row.length;
  }));
}
/**
 * Given a grid areas template, `sourceTemplate`, extrapolate it to fill `targetColumnCount`:
 *
 * For example, the template:
 *
 *     "a a a b c d"
 *     "a a a e f g"
 *
 * Extrapolated to `12` columns:
 *
 *     "a a a a a a b b c c d d"
 *     "a a a a a a e e f f g g"
 *
 * Note: spacing is not preserved.
 */

function extrapolateTemplate(templateString, targetColumnCount) {
  var template = parseTemplate(templateString);
  var scaleFactor = targetColumnCount / template[0].length;

  if (!isInteger(scaleFactor)) {
    throw new Error("Can not evenly extrapolate template " + templateString + " to " + targetColumnCount + " columns.");
  }

  return template.map(function (row) {
    var extrapolatedRow = row.reduce(function (multiplied, areaName) {
      return multiplied.concat(times(scaleFactor, function () {
        return areaName;
      }));
    }, []).join(' ');
    return "\"" + extrapolatedRow + "\"";
  }).join(' ');
}
/**
 * Given a griad areas template, determine if a given area name is present in that template
 */

function doesTemplateIncludeArea(templateString, areaName) {
  return flatten(parseTemplate(templateString)).includes(areaName);
}

/**
 * A mapping of breakpoint names to width values
 *
 * { "xs": "360px", "sm": "768px", "md": "960px", ... }
 */

var BREAKPOINTS = mapKeys(pickBy(cssVars, function (_varValue, varName) {
  return varName.startsWith('breakpoint-');
}), function (_varValue, varName) {
  return varName.slice('breakpoint-'.length).toLowerCase();
});
/**
 * The breakpoint names sorted in ascending order by breakpoint size
 *
 * ["xs", "sm", "md", "lg", ...]
 *
 * Assumes that all breakpoints are defined in the same unit ("px", "rem", etc)
 */

var SORTED_BREAKPOINT_NAMES = Object.keys(BREAKPOINTS).sort(function (a, b) {
  var breakpointA = parseInt(BREAKPOINTS[a], 10);
  var breakpointB = parseInt(BREAKPOINTS[b], 10);
  return breakpointA - breakpointB;
});
/**
 * The breakpoints where the number of columns change:
 *   { "sm": 8, "md": 12 }
 */

var COLUMN_BREAKPOINTS = mapValues(mapKeys(pickBy(cssVars, function (_varValue, varName) {
  return varName.startsWith('columns-');
}), function (_varValue, varName) {
  return varName.slice('columns-'.length).toLowerCase();
}), function (varValue) {
  return parseInt(varValue, 10);
});
/**
 * The COLUMN_BREAKPOINTS, as an array, sorted by number of columns
 *
 * [["sm", 8], ["md", 12]]
 */

var COLUMN_BREAKPOINT_TUPLES = sortBy(toPairs(COLUMN_BREAKPOINTS), function (tuple) {
  return tuple[1];
});
/**
 * Given a breakpoint name (or `null`, representing the "default" breakpoint)
 *   calculate the expected number of columns
 */

function columnCountFromBreakpoint(breakpointName) {
  var columnCount = parseInt(cssVars.defaultColumns, 10);

  if (breakpointName === null) {
    return columnCount;
  }

  for (var _i = 0, SORTED_BREAKPOINT_NAMES_1 = SORTED_BREAKPOINT_NAMES; _i < SORTED_BREAKPOINT_NAMES_1.length; _i++) {
    var otherBreakpointName = SORTED_BREAKPOINT_NAMES_1[_i];

    if (COLUMN_BREAKPOINTS.hasOwnProperty(otherBreakpointName)) {
      columnCount = COLUMN_BREAKPOINTS[otherBreakpointName];
    }

    if (otherBreakpointName == breakpointName) {
      return columnCount;
    }
  }

  return columnCount;
}

var map = {};

var styles$o = {"breakpoint-xs":"360px","breakpoint-sm":"768px","breakpoint-md":"960px","breakpoint-lg":"1200px","breakpoint-xlg":"1440px","breakpoint-xxlg":"1600px","default-columns":"2","columns-sm":"8","columns-md":"12","col-1":"styles_col-1__2BNlB","col-2":"styles_col-2__189Zr","xs-col-1":"styles_xs-col-1__3Aw0a","xs-col-2":"styles_xs-col-2__30GvB","sm-col-1":"styles_sm-col-1__US1rQ","sm-col-2":"styles_sm-col-2__1i0RY","sm-col-3":"styles_sm-col-3__1IHXD","sm-col-4":"styles_sm-col-4__5kwYK","sm-col-5":"styles_sm-col-5__BUzt5","sm-col-6":"styles_sm-col-6__2_cX4","sm-col-7":"styles_sm-col-7__2Zrm3","sm-col-8":"styles_sm-col-8__xGVeN","md-col-1":"styles_md-col-1__2DqmH","md-col-2":"styles_md-col-2__2WNEu","md-col-3":"styles_md-col-3__ZztCl","md-col-4":"styles_md-col-4__zQDOW","md-col-5":"styles_md-col-5__2wHFI","md-col-6":"styles_md-col-6__rOgXY","md-col-7":"styles_md-col-7__fXfRK","md-col-8":"styles_md-col-8__uGVgh","md-col-9":"styles_md-col-9__1JE6h","md-col-10":"styles_md-col-10__3aA_t","md-col-11":"styles_md-col-11__3jkJH","md-col-12":"styles_md-col-12__1RtoU","lg-col-1":"styles_lg-col-1__2xvkV","lg-col-2":"styles_lg-col-2__3iUIl","lg-col-3":"styles_lg-col-3__2EEeN","lg-col-4":"styles_lg-col-4__X-TxL","lg-col-5":"styles_lg-col-5__1gbfo","lg-col-6":"styles_lg-col-6__3m1zS","lg-col-7":"styles_lg-col-7__1Esku","lg-col-8":"styles_lg-col-8__3faSF","lg-col-9":"styles_lg-col-9__z-0rj","lg-col-10":"styles_lg-col-10__IJjQK","lg-col-11":"styles_lg-col-11__s4bar","lg-col-12":"styles_lg-col-12__25NHM","xlg-col-1":"styles_xlg-col-1__3swYJ","xlg-col-2":"styles_xlg-col-2__7j0QE","xlg-col-3":"styles_xlg-col-3__6yHfR","xlg-col-4":"styles_xlg-col-4__2A_O7","xlg-col-5":"styles_xlg-col-5__3ObM7","xlg-col-6":"styles_xlg-col-6__2P0Pb","xlg-col-7":"styles_xlg-col-7__1oeKF","xlg-col-8":"styles_xlg-col-8__2Wwdi","xlg-col-9":"styles_xlg-col-9__3B487","xlg-col-10":"styles_xlg-col-10__1xwME","xlg-col-11":"styles_xlg-col-11__3Pk5B","xlg-col-12":"styles_xlg-col-12__uqjZu","xxlg-col-1":"styles_xxlg-col-1__2rKAo","xxlg-col-2":"styles_xxlg-col-2__3g-HQ","xxlg-col-3":"styles_xxlg-col-3__1VodL","xxlg-col-4":"styles_xxlg-col-4__ZtFFX","xxlg-col-5":"styles_xxlg-col-5__1VGLC","xxlg-col-6":"styles_xxlg-col-6__2Hm7m","xxlg-col-7":"styles_xxlg-col-7__o1pc7","xxlg-col-8":"styles_xxlg-col-8__16FbC","xxlg-col-9":"styles_xxlg-col-9__1B41Y","xxlg-col-10":"styles_xxlg-col-10__3sPN1","xxlg-col-11":"styles_xxlg-col-11__1cfu_","xxlg-col-12":"styles_xxlg-col-12__1bbbb","row-2":"styles_row-2__pY1aL","row-3":"styles_row-3__1r2Fe","row-4":"styles_row-4__7Ytjg","row-5":"styles_row-5__3D11X","row-6":"styles_row-6__3KalP","xs-row-2":"styles_xs-row-2__1KC0n","xs-row-3":"styles_xs-row-3__3vsFf","xs-row-4":"styles_xs-row-4__37SBy","xs-row-5":"styles_xs-row-5__1SrIR","xs-row-6":"styles_xs-row-6__2-M92","sm-row-2":"styles_sm-row-2__3Jrc6","sm-row-3":"styles_sm-row-3__2PUVL","sm-row-4":"styles_sm-row-4__3okvu","sm-row-5":"styles_sm-row-5__-GIhx","sm-row-6":"styles_sm-row-6__2VJtm","md-row-2":"styles_md-row-2__8VvUk","md-row-3":"styles_md-row-3__IO_ss","md-row-4":"styles_md-row-4__4zqbR","md-row-5":"styles_md-row-5__1myKc","md-row-6":"styles_md-row-6__2J6ke","lg-row-2":"styles_lg-row-2__3KLLk","lg-row-3":"styles_lg-row-3__cSV2B","lg-row-4":"styles_lg-row-4__1GN_G","lg-row-5":"styles_lg-row-5__2Zvwg","lg-row-6":"styles_lg-row-6__101_1","xlg-row-2":"styles_xlg-row-2__2pVlH","xlg-row-3":"styles_xlg-row-3__PVMA-","xlg-row-4":"styles_xlg-row-4__346IS","xlg-row-5":"styles_xlg-row-5__3ru5r","xlg-row-6":"styles_xlg-row-6__1D-pJ","xxlg-row-2":"styles_xxlg-row-2__ppRmh","xxlg-row-3":"styles_xxlg-row-3__1y56L","xxlg-row-4":"styles_xxlg-row-4__3MU-o","xxlg-row-5":"styles_xxlg-row-5__3mK_q","xxlg-row-6":"styles_xxlg-row-6__2k-Vu","grid-item-base":"styles_grid-item-base__32oYF","hide":"styles_hide__23mhT","show":"styles_show__ShLdo","xs-hide":"styles_xs-hide__37j4O","xs-show":"styles_xs-show__1rWnY","sm-hide":"styles_sm-hide__jeG1S","sm-show":"styles_sm-show__1o-_v","md-hide":"styles_md-hide__2DhLR","md-show":"styles_md-show__gVteQ","lg-hide":"styles_lg-hide__31eOq","lg-show":"styles_lg-show__1n-oW","xlg-hide":"styles_xlg-hide__1zBca","xlg-show":"styles_xlg-show__YTclr","xxlg-hide":"styles_xxlg-hide__32fq2","xxlg-show":"styles_xxlg-show__19fte","breakpointXs":"360px","breakpointSm":"768px","breakpointMd":"960px","breakpointLg":"1200px","breakpointXlg":"1440px","breakpointXxlg":"1600px","defaultColumns":"2","columnsSm":"8","columnsMd":"12","col1":"styles_col-1__2BNlB","col2":"styles_col-2__189Zr","xsCol1":"styles_xs-col-1__3Aw0a","xsCol2":"styles_xs-col-2__30GvB","smCol1":"styles_sm-col-1__US1rQ","smCol2":"styles_sm-col-2__1i0RY","smCol3":"styles_sm-col-3__1IHXD","smCol4":"styles_sm-col-4__5kwYK","smCol5":"styles_sm-col-5__BUzt5","smCol6":"styles_sm-col-6__2_cX4","smCol7":"styles_sm-col-7__2Zrm3","smCol8":"styles_sm-col-8__xGVeN","mdCol1":"styles_md-col-1__2DqmH","mdCol2":"styles_md-col-2__2WNEu","mdCol3":"styles_md-col-3__ZztCl","mdCol4":"styles_md-col-4__zQDOW","mdCol5":"styles_md-col-5__2wHFI","mdCol6":"styles_md-col-6__rOgXY","mdCol7":"styles_md-col-7__fXfRK","mdCol8":"styles_md-col-8__uGVgh","mdCol9":"styles_md-col-9__1JE6h","mdCol10":"styles_md-col-10__3aA_t","mdCol11":"styles_md-col-11__3jkJH","mdCol12":"styles_md-col-12__1RtoU","lgCol1":"styles_lg-col-1__2xvkV","lgCol2":"styles_lg-col-2__3iUIl","lgCol3":"styles_lg-col-3__2EEeN","lgCol4":"styles_lg-col-4__X-TxL","lgCol5":"styles_lg-col-5__1gbfo","lgCol6":"styles_lg-col-6__3m1zS","lgCol7":"styles_lg-col-7__1Esku","lgCol8":"styles_lg-col-8__3faSF","lgCol9":"styles_lg-col-9__z-0rj","lgCol10":"styles_lg-col-10__IJjQK","lgCol11":"styles_lg-col-11__s4bar","lgCol12":"styles_lg-col-12__25NHM","xlgCol1":"styles_xlg-col-1__3swYJ","xlgCol2":"styles_xlg-col-2__7j0QE","xlgCol3":"styles_xlg-col-3__6yHfR","xlgCol4":"styles_xlg-col-4__2A_O7","xlgCol5":"styles_xlg-col-5__3ObM7","xlgCol6":"styles_xlg-col-6__2P0Pb","xlgCol7":"styles_xlg-col-7__1oeKF","xlgCol8":"styles_xlg-col-8__2Wwdi","xlgCol9":"styles_xlg-col-9__3B487","xlgCol10":"styles_xlg-col-10__1xwME","xlgCol11":"styles_xlg-col-11__3Pk5B","xlgCol12":"styles_xlg-col-12__uqjZu","xxlgCol1":"styles_xxlg-col-1__2rKAo","xxlgCol2":"styles_xxlg-col-2__3g-HQ","xxlgCol3":"styles_xxlg-col-3__1VodL","xxlgCol4":"styles_xxlg-col-4__ZtFFX","xxlgCol5":"styles_xxlg-col-5__1VGLC","xxlgCol6":"styles_xxlg-col-6__2Hm7m","xxlgCol7":"styles_xxlg-col-7__o1pc7","xxlgCol8":"styles_xxlg-col-8__16FbC","xxlgCol9":"styles_xxlg-col-9__1B41Y","xxlgCol10":"styles_xxlg-col-10__3sPN1","xxlgCol11":"styles_xxlg-col-11__1cfu_","xxlgCol12":"styles_xxlg-col-12__1bbbb","row2":"styles_row-2__pY1aL","row3":"styles_row-3__1r2Fe","row4":"styles_row-4__7Ytjg","row5":"styles_row-5__3D11X","row6":"styles_row-6__3KalP","xsRow2":"styles_xs-row-2__1KC0n","xsRow3":"styles_xs-row-3__3vsFf","xsRow4":"styles_xs-row-4__37SBy","xsRow5":"styles_xs-row-5__1SrIR","xsRow6":"styles_xs-row-6__2-M92","smRow2":"styles_sm-row-2__3Jrc6","smRow3":"styles_sm-row-3__2PUVL","smRow4":"styles_sm-row-4__3okvu","smRow5":"styles_sm-row-5__-GIhx","smRow6":"styles_sm-row-6__2VJtm","mdRow2":"styles_md-row-2__8VvUk","mdRow3":"styles_md-row-3__IO_ss","mdRow4":"styles_md-row-4__4zqbR","mdRow5":"styles_md-row-5__1myKc","mdRow6":"styles_md-row-6__2J6ke","lgRow2":"styles_lg-row-2__3KLLk","lgRow3":"styles_lg-row-3__cSV2B","lgRow4":"styles_lg-row-4__1GN_G","lgRow5":"styles_lg-row-5__2Zvwg","lgRow6":"styles_lg-row-6__101_1","xlgRow2":"styles_xlg-row-2__2pVlH","xlgRow3":"styles_xlg-row-3__PVMA-","xlgRow4":"styles_xlg-row-4__346IS","xlgRow5":"styles_xlg-row-5__3ru5r","xlgRow6":"styles_xlg-row-6__1D-pJ","xxlgRow2":"styles_xxlg-row-2__ppRmh","xxlgRow3":"styles_xxlg-row-3__1y56L","xxlgRow4":"styles_xxlg-row-4__3MU-o","xxlgRow5":"styles_xxlg-row-5__3mK_q","xxlgRow6":"styles_xxlg-row-6__2k-Vu","gridItemBase":"styles_grid-item-base__32oYF","xsHide":"styles_xs-hide__37j4O","xsShow":"styles_xs-show__1rWnY","smHide":"styles_sm-hide__jeG1S","smShow":"styles_sm-show__1o-_v","mdHide":"styles_md-hide__2DhLR","mdShow":"styles_md-show__gVteQ","lgHide":"styles_lg-hide__31eOq","lgShow":"styles_lg-show__1n-oW","xlgHide":"styles_xlg-hide__1zBca","xlgShow":"styles_xlg-show__YTclr","xxlgHide":"styles_xxlg-hide__32fq2","xxlgShow":"styles_xxlg-show__19fte"};

var GridItem = function GridItem(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var responsiveProps = ['col', 'xsCol', 'smCol', 'mdCol', 'lgCol', 'xlgCol', 'xxlgCol', 'row', 'xsRow', 'smRow', 'mdRow', 'lgRow', 'xlgRow', 'xxlgRow'];
  var responsiveClassNames = responsiveProps.map(function (propName) {
    var propValue = rest[propName];
    var className = styles$o["" + propName + rest[propName]];

    if (propValue !== undefined && !className) {
      console.warn("<GridItem " + propName + "=\"" + propValue + "\" />: \"" + propValue + "\" is not a valid value for \"" + propName + "\"");
    }

    return className;
  });
  return React.createElement("div", __assign({
    className: classnames(styles$o['grid-item-base'], className, responsiveClassNames)
  }, omit(rest, responsiveProps)));
};

function nextBreakpointWithArea(templates, breakpointName, areaName) {
  var templateBreakpointNames = Object.keys(templates);

  var sortedTemplateBreakpointNames = __spreadArrays(['default'], SORTED_BREAKPOINT_NAMES).filter(function (breakpointName) {
    return templateBreakpointNames.includes(breakpointName);
  });

  var largerTemplateBreakpointNames = sortedTemplateBreakpointNames.slice(sortedTemplateBreakpointNames.indexOf(breakpointName || 'default'));
  return largerTemplateBreakpointNames.find(function (templateBreakpointName) {
    return doesTemplateIncludeArea(templates[templateBreakpointName], areaName);
  });
}

function parseTemplatesToComponents(gridTemplates) {
  //  For each grid, we memoize the generated AreaComponentMap so they are re-used across renders.
  //  This has performance benefits, but more importantly it prevents the Grid's children from
  //  losing state across renders (without memoization the AreaComponents would be distinct
  //  constructors with each render)
  var templatesHash = hash(gridTemplates);

  if (map[templatesHash]) {
    return map[templatesHash];
  } // Parse each template into a matrix
  //  { 'default' : [['a', 'b'], ['a, 'b']], 'md' : [['foo', 'bar'], ['foo', 'bar']] }


  var parsedTemplates = mapValues(gridTemplates, parseTemplate); // Flatten the templates since we don't care about rows & columns
  //  { 'default' : ['a', 'b', 'a', 'b'], 'md' : ['foo', 'bar', 'foo', 'bar'] }

  var flattenedTemplates = mapValues(parsedTemplates, flatten); // Find all the unique area name tokens across all the grid templates

  var uniqueAreaNames = uniq(flatten(Object.values(flattenedTemplates))); // Build an object mapping raw area names to React components with the `grid-area` preset

  var componentsMap = uniqueAreaNames.reduce(function (components, areaName) {
    var displayName = upperFirst(camelCase(areaName));

    var Component = function Component(_a) {
      var style = _a.style,
          className = _a.className,
          rest = __rest(_a, ["style", "className"]);

      var responsiveClassNames = []; // If this area name isn't used in a given area template, add classes to hide it until
      //   the device reaches the next breakpoint that has a template with that area name.

      for (var _i = 0, _b = Object.entries(flattenedTemplates); _i < _b.length; _i++) {
        var _c = _b[_i],
            breakpointName = _c[0],
            templateAreas = _c[1];

        if (!templateAreas.includes(areaName)) {
          responsiveClassNames.push(styles$o[breakpointName === 'default' ? 'hide' : breakpointName + "-hide"]);
          var nextBreakpointName = nextBreakpointWithArea(gridTemplates, breakpointName, areaName);

          if (nextBreakpointName) {
            responsiveClassNames.push(styles$o[nextBreakpointName === 'default' ? 'show' : nextBreakpointName + "-show"]);
          }
        }
      }

      return React.createElement(GridItem, __assign({
        style: __assign({
          gridArea: areaName
        }, style),
        className: classnames(className, responsiveClassNames)
      }, rest));
    };

    Component.displayName = "GridItem(" + displayName + ")";
    components[displayName] = Component;
    return components;
  }, {}); // Memoize

  map[templatesHash] = componentsMap;
  return componentsMap;
}

var AREAS_PROP_NAMES = __spreadArrays(['areas'], SORTED_BREAKPOINT_NAMES.map(function (breakpointName) {
  return "areas" + upperFirst(breakpointName);
}));
/**
 * Infer missing breakpoint props from a given `ResponsiveGridAreaProps`:
 *   i.e. { "areasXs": "a b c", "areasSm": "a a a b b c", ... }
 *
 * For each breakpoint where the number of columns change, we attempt to extrapolate
 *   the template from the closest smaller breakpoint with a template provided.
 */


function extrapolateProps(providedProps) {
  // Copy the props and re-type with an index signature so we can dynamically access `areasX` later
  var extrapolatedProps = Object.assign({}, providedProps); // COLUMN_BREAKPOINT_TUPLES contains a set of each breakpoint at which the number of columns changes

  COLUMN_BREAKPOINT_TUPLES.forEach(function (_a) {
    var columnBreakpointName = _a[0],
        columnCount = _a[1];
    var areasPropName = "areas" + upperFirst(columnBreakpointName); // If we already have a template for this breakpoint, skip

    if (providedProps.hasOwnProperty(areasPropName)) {
      return;
    } // Otherwise, find the closest smaller template and extrapolate from there


    var smallerPropNames = AREAS_PROP_NAMES.slice(0, AREAS_PROP_NAMES.indexOf("areas" + upperFirst(columnBreakpointName)));
    var sourceTemplate = null;

    for (var _i = 0, _b = smallerPropNames.reverse(); _i < _b.length; _i++) {
      var areasPropName_1 = _b[_i];
      var smallerBreakpointTemplate = providedProps[areasPropName_1];

      if (smallerBreakpointTemplate) {
        sourceTemplate = smallerBreakpointTemplate;
        break;
      }
    } // Extrapolate the template to the next breakpoint where the number of columns change


    if (sourceTemplate) {
      extrapolatedProps[areasPropName] = extrapolateTemplate(sourceTemplate, columnCount);
    }
  });
  return extrapolatedProps;
}

var styles$p = {"breakpoint-xs":"360px","breakpoint-sm":"768px","breakpoint-md":"960px","breakpoint-lg":"1200px","breakpoint-xlg":"1440px","breakpoint-xxlg":"1600px","default-columns":"2","columns-sm":"8","columns-md":"12","wrapper":"styles_wrapper__3iSpY flex flex-auto flex-row justify-center","grid":"styles_grid__257_T mx-auto","grid-margins":"styles_grid-margins__3YrTX","grid-row-gaps":"styles_grid-row-gaps__18f__","breakpointXs":"360px","breakpointSm":"768px","breakpointMd":"960px","breakpointLg":"1200px","breakpointXlg":"1440px","breakpointXxlg":"1600px","defaultColumns":"2","columnsSm":"8","columnsMd":"12","gridMargins":"styles_grid-margins__3YrTX","gridRowGaps":"styles_grid-row-gaps__18f__"};

var Grid = function Grid(_a) {
  var _b;

  var className = _a.className,
      wrapperClassName = _a.wrapperClassName,
      _c = _a.margins,
      margins = _c === void 0 ? true : _c,
      _d = _a.rowGaps,
      rowGaps = _d === void 0 ? false : _d,
      rest = __rest(_a, ["className", "wrapperClassName", "margins", "rowGaps"]);

  return React.createElement("div", {
    className: classnames(styles$p.wrapper, wrapperClassName)
  }, React.createElement("div", __assign({
    className: classnames(className, styles$p.grid, (_b = {}, _b[styles$p.gridMargins] = margins, _b[styles$p.gridRowGaps] = rowGaps, _b))
  }, rest)));
};

var ResponsiveGrid = function ResponsiveGrid(_a) {
  var style = _a.style,
      className = _a.className,
      children = _a.children,
      rest = __rest(_a, ["style", "className", "children"]);

  var responsiveAreasPropNames = ['areas', 'areasXs', 'areasSm', 'areasMd', 'areasLg', 'areasXlg', 'areasXxlg'];
  var responsiveAreaProps = pick(rest, responsiveAreasPropNames);
  var passthroughProps = omit(rest, responsiveAreasPropNames);
  var extrapolatedAreasProps = extrapolateProps(rest); // Build a map of { breakpoint: template } for all provided area templates

  var allTemplates = {};

  for (var _i = 0, _b = Object.entries(responsiveAreaProps); _i < _b.length; _i++) {
    var _c = _b[_i],
        areaPropName = _c[0],
        areaTemplate = _c[1];

    if (areaTemplate) {
      var breakpointName = areaPropName.slice(5).toLowerCase() || 'default';
      allTemplates[breakpointName] = areaTemplate;
    }
  } // Generate a unique ID for this grid


  var id = hash(allTemplates).slice(0, 8);
  var cssBlocks = [];
  responsiveAreasPropNames.forEach(function (propName) {
    // "areasXs" => "xs"
    var breakpointName = propName.slice(5).toLowerCase() || null; // "areasXs" => "xs"
    // "xs"  => "360px"

    var breakpointSize = cssVars["breakpoint-" + breakpointName] || undefined; // The template value for this breakpoint: "a a b b" "c c c c"

    var templateAreas = extrapolatedAreasProps[propName];

    if (templateAreas) {
      var expectedColumns = columnCountFromBreakpoint(breakpointName);
      var templatedColumns = columnCountFromTemplate(templateAreas);

      if (expectedColumns !== templatedColumns) {
        throw new Error("Expected the \"" + propName + "\" template to have " + expectedColumns + " columns, but found " + templatedColumns + ": " + templateAreas);
      }

      var cssRule = ".grid-" + id + " { grid-template-areas: " + minifyTemplate(templateAreas) + " }";
      var mediaQueryFeatures = [];

      if (breakpointSize) {
        mediaQueryFeatures.push("(min-width: " + breakpointSize + ")");
        cssBlocks.push("@media " + mediaQueryFeatures.join(' and ') + " { " + cssRule + " }");
      } else {
        cssBlocks.push(cssRule);
      }
    }
  });
  return React.createElement(React.Fragment, null, cssBlocks.length > 0 && React.createElement("style", {
    type: "text/css",
    dangerouslySetInnerHTML: {
      __html: cssBlocks.join('\n')
    }
  }), React.createElement(Grid, __assign({
    className: classnames(className, "grid-" + id)
  }, passthroughProps), typeof children === 'function' ? children(parseTemplatesToComponents(allTemplates)) : children));
};

var _extends$w = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$w(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var DealIconMark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$w(_ref, ["styles"]);

  return React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "28",
    viewBox: "0 0 22 28"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.743 0a1.28 1.28 0 0 1 1.278 1.283c-.002 2.88-.004 9.77-.002 11.947 0 .456-.158.896-.45 1.247L9.903 27.329a1.537 1.537 0 0 1-1.409.538C3.557 27.143 0 22.12 0 17.593 0 11.88 4.628 7.23 10.317 7.23c1.347 0 2.905.352 4.508 1.018l.943.405V1.269c0-.7.565-1.269 1.263-1.269h2.712zm-.982 20.29c.619-.747 1.628-.743 2.194.044a4.82 4.82 0 0 1 .896 2.557c.127 2.255-1.395 4.336-3.574 4.896a4.745 4.745 0 0 1-3.195-.286c-.914-.424-1.134-1.408-.49-2.185l4.17-5.027zM8.615 21.764c.463-.462 5.366-6.314 5.366-6.314.592-.804.11-1.583-.148-1.796a5.291 5.291 0 0 0-3.258-1.232c-2.978-.064-5.421 2.351-5.421 5.329 0 1.552.672 3.011 1.821 4.019.467.41 1.177.457 1.64-.006z"
  }));
});

var _extends$x = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$x(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var DealWordmark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$x(_ref, ["styles"]);

  return React.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: "75",
    height: "28",
    viewBox: "0 0 75 28"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M29.234 15.258s.72-3.352 4.286-3.352c3.682 0 4.19 3.352 4.19 3.352h-8.476zm13.826 1.409c0 .6-.047 1.177-.1 1.648a1.258 1.258 0 0 1-1.248 1.118H29.136s.861 3.755 5.24 3.755c1.599 0 3.146-.593 4.092-1.239a1.339 1.339 0 0 1 1.764.226l1.3 1.486c.51.583.427 1.478-.183 1.956C39.995 26.68 37.43 28 34.124 28c-5.793 0-10.143-4.569-10.143-10.21 0-5.884 4.244-10.559 9.855-10.559 6.84 0 9.224 5.674 9.224 9.436zM19.743.004a1.28 1.28 0 0 1 1.278 1.283c-.002 2.879-.004 9.769-.002 11.946 0 .457-.158.896-.45 1.247L9.903 27.333a1.537 1.537 0 0 1-1.409.538C3.557 27.147 0 22.124 0 17.597 0 11.883 4.628 7.234 10.317 7.234c1.347 0 2.905.352 4.508 1.017l.943.405V1.273c0-.701.565-1.27 1.263-1.27h2.712zm-.982 20.289c.619-.746 1.628-.742 2.194.044a4.82 4.82 0 0 1 .896 2.557c.127 2.256-1.395 4.337-3.574 4.897a4.745 4.745 0 0 1-3.195-.287c-.914-.424-1.134-1.407-.49-2.185l4.17-5.026zM69.746 1.209c0-.667.54-1.209 1.204-1.209h2.846C74.461 0 75 .542 75 1.21v25.154c0 .663-.535 1.2-1.195 1.2H70.94c-.66 0-1.195-.537-1.195-1.2V1.209zm-8.87 7.393c0-.682.535-1.091 1.214-1.091h2.706c.68 0 1.23.553 1.23 1.235v17.575a1.24 1.24 0 0 1-1.238 1.243H63.74c-.43 0-.828-.232-1.04-.61l-.88-1.559s-2.246 2.49-5.976 2.49c-5.487 0-10.135-4.27-10.423-9.774-.311-5.946 4.416-10.883 10.269-10.883 2.372 0 4.181.758 5.186 1.374zM8.615 21.77c.463-.463 5.366-6.314 5.366-6.314.592-.805.11-1.583-.148-1.797a5.291 5.291 0 0 0-3.258-1.231c-2.978-.064-5.421 2.35-5.421 5.328 0 1.552.672 3.012 1.821 4.02.467.409 1.177.456 1.64-.006zm47.142 1.072c2.904 0 5.267-2.373 5.267-5.29 0-2.918-2.363-5.29-5.267-5.29-2.904 0-5.267 2.372-5.267 5.29 0 2.917 2.363 5.29 5.267 5.29z"
  }));
});

var _extends$y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$y(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedIconMark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$y(_ref, ["styles"]);

  return React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "28",
    viewBox: "0 0 28 28"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2-2h32v32H-2z"
  }), React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M2 2v24h24V2H2zM0 0h28v28H0V0z"
  }), React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M8.5 13.826c0-1.189.291-2.278.873-3.244a6.146 6.146 0 0 1 2.356-2.273 6.679 6.679 0 0 1 3.24-.809c.945 0 1.841.191 2.677.574.824.385 1.54.924 2.144 1.615l.331.38-2.142 1.847-.328-.367a3.642 3.642 0 0 0-1.195-.896 3.504 3.504 0 0 0-1.488-.315c-.995 0-1.806.327-2.456.987-.66.67-.985 1.488-.985 2.501 0 1.014.324 1.83.984 2.488.652.66 1.465.987 2.457.987.538 0 1.041-.109 1.513-.325a3.362 3.362 0 0 0 1.193-.901l.327-.39 2.128 1.849-.316.376a6.19 6.19 0 0 1-2.15 1.644 6.287 6.287 0 0 1-2.695.59 6.7 6.7 0 0 1-2.51-.476 6.353 6.353 0 0 1-2.061-1.31 6.157 6.157 0 0 1-1.386-2.014 6.207 6.207 0 0 1-.511-2.518z"
  })));
});

var _extends$z = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$z(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedWordmark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$z(_ref, ["styles"]);

  return React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: "108",
    height: "16",
    viewBox: "0 0 108 16"
  }, props), React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M0 8.242c0 1.105.207 2.135.626 3.09.421.969.986 1.79 1.698 2.472a7.805 7.805 0 0 0 2.534 1.608 8.27 8.27 0 0 0 3.1.588c1.172 0 2.273-.24 3.31-.725a7.587 7.587 0 0 0 2.638-2.016l-1.83-1.59a5.15 5.15 0 0 1-1.823 1.378 5.439 5.439 0 0 1-2.296.495c-1.497 0-2.752-.506-3.75-1.514-1.004-1.001-1.504-2.26-1.504-3.786 0-1.525.5-2.784 1.504-3.803.998-1.012 2.253-1.515 3.75-1.515.808 0 1.563.158 2.263.481a5.53 5.53 0 0 1 1.813 1.357l1.852-1.597a7.916 7.916 0 0 0-2.639-1.988A7.816 7.816 0 0 0 7.957.474c-1.455 0-2.784.337-4 .997A7.527 7.527 0 0 0 1.07 4.26C.354 5.447 0 6.782 0 8.242zm18.098 1.726c0 .976.157 1.859.472 2.627.315.779.754 1.41 1.309 1.89a5.586 5.586 0 0 0 1.926 1.117 7.32 7.32 0 0 0 2.388.376c.851 0 1.645-.125 2.367-.376a5.619 5.619 0 0 0 1.92-1.116c.554-.48.983-1.112 1.297-1.891.304-.768.461-1.65.461-2.627V.736h-2.702v8.956c0 1.295-.293 2.25-.89 2.881-.597.632-1.416.948-2.453.948-1.058 0-1.894-.316-2.491-.948-.597-.631-.901-1.586-.901-2.881V.736h-2.703v9.232zm16.473 5.77h2.702V10.42h2.66l3.175 5.318h3.067l-3.621-5.981a4.28 4.28 0 0 0 1.977-1.662c.493-.768.743-1.629.743-2.605 0-.886-.218-1.693-.658-2.43a4.728 4.728 0 0 0-1.77-1.714 4.99 4.99 0 0 0-2.44-.61H34.57v15.002zm2.702-7.747V3.186h3.071c.637 0 1.173.22 1.602.664.418.442.63.998.63 1.68 0 .725-.223 1.313-.673 1.765-.45.463-1.048.696-1.77.696h-2.86zm11.36 7.747h2.856l1.33-2.881h6.431l1.309 2.881h2.903L56.058 0l-7.425 15.738zm5.216-5.235l2.188-4.837 2.188 4.837h-4.376zm15.777 5.235h2.703V3.186h4.054V.736H65.565v2.45h4.061v12.552zm10.845-4.783c0 1.546.4 2.734 1.183 3.552.787.822 1.97 1.231 3.532 1.231h4.766v-2.45h-4.63c-.232 0-.46-.03-.683-.105a2.264 2.264 0 0 1-.69-.337 1.567 1.567 0 0 1-.554-.703c-.146-.316-.221-.693-.221-1.123V9.168h6.198v-2.45h-6.198V3.185h6.631V.736h-9.334v10.219zm14.31 4.783h5.383c1.248 0 2.356-.18 3.353-.545.994-.37 1.812-.876 2.47-1.536a6.747 6.747 0 0 0 1.498-2.365c.347-.915.515-1.923.515-3.028s-.179-2.114-.525-3.029a6.942 6.942 0 0 0-1.499-2.386c-.657-.66-1.476-1.187-2.47-1.554-.997-.369-2.116-.56-3.364-.56H94.78v15.003zm2.702-2.45V3.185h2.474c.961 0 1.801.126 2.502.377.7.255 1.244.61 1.655 1.073.408.474.7 1.001.901 1.6.186.6.282 1.281.282 2.028 0 .578-.053 1.116-.168 1.607a4.56 4.56 0 0 1-.575 1.378c-.261.43-.597.79-1.008 1.084-.408.305-.908.534-1.505.703-.608.169-1.302.251-2.067.251h-2.491z"
  }));
});

var _extends$A = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$A(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var CuratedCombomark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$A(_ref, ["styles"]);

  return React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: "148",
    height: "28",
    viewBox: "0 0 148 28"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#222",
    d: "M40 14.242c0 1.105.207 2.135.626 3.09.421.969.986 1.79 1.698 2.472a7.805 7.805 0 0 0 2.534 1.608 8.27 8.27 0 0 0 3.1.588c1.172 0 2.273-.24 3.31-.725a7.587 7.587 0 0 0 2.638-2.016l-1.83-1.59a5.15 5.15 0 0 1-1.823 1.378 5.439 5.439 0 0 1-2.296.495c-1.497 0-2.752-.506-3.75-1.514-1.004-1.001-1.504-2.26-1.504-3.786 0-1.525.5-2.784 1.504-3.803.998-1.012 2.253-1.515 3.75-1.515.808 0 1.563.158 2.263.481a5.53 5.53 0 0 1 1.813 1.357l1.852-1.597a7.916 7.916 0 0 0-2.639-1.988 7.816 7.816 0 0 0-3.289-.703c-1.455 0-2.784.337-4 .997a7.527 7.527 0 0 0-2.888 2.788C40.354 11.447 40 12.782 40 14.242zm18.098 1.726c0 .976.157 1.859.472 2.627.315.779.754 1.41 1.309 1.89a5.586 5.586 0 0 0 1.926 1.117 7.32 7.32 0 0 0 2.388.376c.851 0 1.645-.125 2.367-.376a5.619 5.619 0 0 0 1.92-1.116c.554-.48.983-1.112 1.297-1.891.304-.768.461-1.65.461-2.627V6.736h-2.702v8.956c0 1.295-.293 2.25-.89 2.881-.597.632-1.416.948-2.453.948-1.058 0-1.894-.316-2.491-.948-.597-.631-.901-1.586-.901-2.881V6.736h-2.703v9.232zm16.473 5.77h2.702V16.42h2.66l3.175 5.318h3.067l-3.621-5.981a4.28 4.28 0 0 0 1.977-1.662c.493-.768.743-1.629.743-2.605 0-.886-.218-1.693-.658-2.43a4.728 4.728 0 0 0-1.77-1.714 4.99 4.99 0 0 0-2.44-.61H74.57v15.002zm2.702-7.747V9.186h3.071c.637 0 1.173.22 1.602.664.418.442.63.998.63 1.68 0 .725-.223 1.313-.673 1.765-.45.463-1.048.696-1.77.696h-2.86zm11.36 7.747h2.856l1.33-2.881h6.431l1.309 2.881h2.903L96.058 6l-7.425 15.738zm5.216-5.235l2.188-4.837 2.188 4.837h-4.376zm15.777 5.235h2.703V9.186h4.054v-2.45h-10.818v2.45h4.061v12.552zm10.845-4.783c0 1.546.4 2.734 1.183 3.552.787.822 1.97 1.231 3.532 1.231h4.766v-2.45h-4.63c-.232 0-.46-.03-.683-.105a2.264 2.264 0 0 1-.69-.337 1.567 1.567 0 0 1-.554-.703c-.146-.316-.221-.693-.221-1.123v-1.852h6.198v-2.45h-6.198V9.185h6.631v-2.45h-9.334v10.219zm14.31 4.783h5.383c1.248 0 2.356-.18 3.353-.545.994-.37 1.812-.876 2.47-1.536a6.747 6.747 0 0 0 1.498-2.365c.347-.915.515-1.923.515-3.028s-.179-2.114-.525-3.029a6.942 6.942 0 0 0-1.499-2.386c-.657-.66-1.476-1.187-2.47-1.554-.997-.369-2.116-.56-3.364-.56h-5.362v15.003zm2.702-2.45V9.185h2.474c.961 0 1.801.126 2.502.377.7.255 1.244.61 1.655 1.073.408.474.7 1.001.901 1.6.186.6.282 1.281.282 2.028 0 .578-.053 1.116-.168 1.607a4.56 4.56 0 0 1-.575 1.378c-.261.43-.597.79-1.008 1.084-.408.305-.908.534-1.505.703-.608.169-1.302.251-2.067.251h-2.491z"
  }), React.createElement("path", {
    fill: "#434343",
    fillRule: "nonzero",
    d: "M2 2v24h24V2H2zM0 0h28v28H0V0z"
  })));
});

var styles$q = {"light":"styles_light__1WCxS","dark":"styles_dark__1zpyI","inherit":"styles_inherit__Mh8H2"};

function getMark(mark, brand) {
  if (mark === void 0) {
    mark = 'word';
  }

  if (brand === void 0) {
    brand = 'curated';
  }

  switch (mark) {
    case 'icon':
      return brand === 'deal' ? DealIconMark : CuratedIconMark;

    case 'word':
      return brand === 'deal' ? DealWordmark : CuratedWordmark;

    case 'combo':
      return brand === 'deal' ? DealWordmark : CuratedCombomark;
  }
}

var Logo = function Logo(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'inherit' : _b,
      mark = _a.mark,
      brand = _a.brand,
      className = _a.className,
      rest = __rest(_a, ["color", "mark", "brand", "className"]);

  var Mark = getMark(mark, brand);
  var classes = classnames(styles$q[color], className);
  return React.createElement(Mark, __assign({
    className: classes
  }, rest));
};

var styles$r = {"overlay":"styles_overlay__2tQmZ flex flex-column justify-center items-center","modal":"styles_modal__vKCeG","modalContent":"styles_modalContent__EPVMn"};

var Modal = function Modal(_a) {
  var children = _a.children,
      isOpen = _a.isOpen,
      className = _a.className,
      overlayClassName = _a.overlayClassName,
      _b = _a.isScrollLockActive,
      isScrollLockActive = _b === void 0 ? true : _b,
      props = __rest(_a, ["children", "isOpen", "className", "overlayClassName", "isScrollLockActive"]);

  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  return React.createElement(ReactModal, __assign({}, props, {
    isOpen: isOpen,
    className: classnames(styles$r.modal, className),
    overlayClassName: classnames(styles$r.overlay, overlayClassName)
  }), React.createElement(ScrollLock, {
    isActive: isScrollLockActive
  }, React.createElement("div", {
    className: styles$r.modalContent
  }, children)));
};

var styles$s = {"breakpoint-sm":"(min-width: 768px)","overlay":"styles_overlay__34DOi flex flex-column justify-end","modal":"styles_modal__2giXn flex flex-column","modalContent":"styles_modalContent__2Pz0P flex flex-column","closeContainer":"styles_closeContainer__1pWIL flex justify-center items-center absolute","close":"styles_close__1Bj9x","breakpointSm":"(min-width: 768px)"};

var _extends$B = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$B(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Close = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$B(_ref, ["styles"]);

  return React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, props), React.createElement("path", {
    fillRule: "nonzero",
    d: "M.3 13.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3L7 8.4l5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L8.4 7l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L7 5.6 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L5.6 7 .3 12.3c-.4.4-.4 1 0 1.4z"
  }));
});

var FancyModal = function FancyModal(_a) {
  var children = _a.children,
      disableScrollLock = _a.disableScrollLock,
      isOpen = _a.isOpen,
      onRequestClose = _a.onRequestClose,
      className = _a.className,
      modalContentClassName = _a.modalContentClassName,
      overlayClassName = _a.overlayClassName,
      closeTestId = _a.closeTestId,
      rest = __rest(_a, ["children", "disableScrollLock", "isOpen", "onRequestClose", "className", "modalContentClassName", "overlayClassName", "closeTestId"]);

  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  var animationProps = useSpring({
    transform: isOpen ? 'translateY(0%)' : 'translateY(100%)'
  });
  return React.createElement(ReactModal, __assign({
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: classnames(styles$s.modal, className),
    overlayClassName: classnames(styles$s.overlay, overlayClassName)
  }, rest), React.createElement(ScrollLock, {
    isActive: disableScrollLock ? false : isOpen
  }), React.createElement(React.Fragment, null, onRequestClose && React.createElement("div", {
    className: styles$s.closeContainer,
    "data-testid": closeTestId,
    onClick: function onClick(e) {
      return onRequestClose && onRequestClose(e);
    }
  }, React.createElement(Close, {
    className: styles$s.close
  })), React.createElement(TouchScrollable, null, React.createElement(animated.div, {
    className: classnames(styles$s.modalContent, modalContentClassName),
    style: animationProps
  }, children))));
};

var styles$t = {"breakpoint-sm":"(min-width: 768px)","overlay":"styles_overlay__36LsF flex flex-column items-center justify-center","modal":"styles_modal__1rER3","modalContent":"styles_modalContent__1V1MD","closeContainer":"styles_closeContainer__YYCGd flex justify-center items-center absolute","close":"styles_close__2a_dh","small":"styles_small__IuGfC","medium":"styles_medium__1RHmX","large":"styles_large__3NQXu","breakpointSm":"(min-width: 768px)"};

var _extends$C = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$C(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Close$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$C(_ref, ["styles"]);

  return React.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, props), React.createElement("path", {
    fillRule: "nonzero",
    d: "M.3 13.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3L7 8.4l5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L8.4 7l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L7 5.6 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4L5.6 7 .3 12.3c-.4.4-.4 1 0 1.4z"
  }));
});

var SimpleModal = function SimpleModal(_a) {
  var children = _a.children,
      onRequestClose = _a.onRequestClose,
      className = _a.className,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      overlayClassName = _a.overlayClassName,
      closeTestId = _a.closeTestId,
      props = __rest(_a, ["children", "onRequestClose", "className", "size", "overlayClassName", "closeTestId"]);

  useEffect(function () {
    ReactModal.setAppElement('body');
  }, []);
  return React.createElement(ReactModal, __assign({}, props, {
    onRequestClose: onRequestClose,
    className: classnames(styles$t.modal, className, styles$t[size]),
    overlayClassName: classnames(styles$t.overlay, overlayClassName)
  }), onRequestClose && React.createElement("div", {
    className: styles$t.closeContainer,
    "data-testid": closeTestId,
    onClick: function onClick(e) {
      return onRequestClose && onRequestClose(e);
    }
  }, React.createElement(Close$1, {
    className: styles$t.close
  })), React.createElement(ScrollLock, null, React.createElement("div", {
    className: styles$t.modalContent
  }, children)));
};

var styles$u = {"breakpoint-sm":"(min-width: 768px)","showcase":"styles_showcase__1Uhck","hideInMobile":"styles_hideInMobile__3IpcV","breakpointSm":"(min-width: 768px)"};

var FancyShowcase = function FancyShowcase(_a) {
  var _b;

  var children = _a.children,
      className = _a.className,
      _c = _a.hideInMobile,
      hideInMobile = _c === void 0 ? false : _c;
  return React.createElement("div", {
    className: classnames(styles$u.showcase, className, (_b = {}, _b[styles$u.hideInMobile] = !!hideInMobile, _b))
  }, children);
};

var styles$v = {"breakpoint-sm":"(min-width: 768px)","content":"styles_content__3HSVw","breakpointSm":"(min-width: 768px)"};

var FancyContent = function FancyContent(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$v.content, className)
  }, children);
};

var styles$w = {"breakpoint-sm":"(min-width: 768px)","title":"styles_title__3vnhf bold","breakpointSm":"(min-width: 768px)"};

var ModalTitle = function ModalTitle(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$w.title, className)
  }, children);
};

var styles$x = {"breakpoint-sm":"(min-width: 768px)","footer":"styles_footer__3bR4e","breakpointSm":"(min-width: 768px)"};

var ModalFooter = function ModalFooter(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$x.footer, className)
  }, children);
};

var styles$y = {"breakpoint-sm":"(min-width: 768px)","modalContent":"styles_modalContent__2JBNW","breakpointSm":"(min-width: 768px)"};

var ModalContent = function ModalContent(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$y.modalContent, className)
  }, children);
};

var _extends$D = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$D(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Check = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$D(_ref, ["styles"]);

  return React.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.56 11.01l4.07-4.07a.999.999 0 1 0-1.414-1.415L6.732 8.89l-.829-.829A1 1 0 0 0 4.49 9.475l1.536 1.535a.999.999 0 0 0 1.414 0z"
  }));
});

var _extends$E = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$E(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Error$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$E(_ref, ["styles"]);

  return React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm9.315 2.718a.993.993 0 0 0 1.403-1.403L9.41 8.007l1.308-1.309a.993.993 0 0 0-1.403-1.403L8.007 6.603 6.694 5.291a.991.991 0 1 0-1.403 1.403l1.312 1.312-1.312 1.313a.991.991 0 1 0 1.403 1.403L8.007 9.41l1.308 1.308z"
  }));
});

var styles$z = {"box":"styles_box__2eyXR","padding":"styles_padding__54EK1","icon":"styles_icon__21hrL","info":"styles_info__1gOUZ styles_box__2eyXR","error":"styles_error__HAOVj styles_box__2eyXR","success":"styles_success__1Jkoc styles_box__2eyXR","label":"styles_label__2MPQf"};

var Notification = function Notification(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'info' : _b,
      children = _a.children,
      className = _a.className;
  var classes = classnames(styles$z[type], className);
  var Glyph = Check;

  if (type === 'error') {
    Glyph = Error$1;
  }

  return React.createElement("div", {
    className: classes
  }, React.createElement("div", {
    className: styles$z.padding
  }, React.createElement(Glyph, {
    className: styles$z.icon
  }), React.createElement("span", {
    className: styles$z.label
  }, children)));
};

/**
 * This repository is relatively unmaintained, so there are some long standing issues with the
 * phone mask backspace working with guide set to false. This is a work around that will work
 * for as long as we are using a US phone number mask.
 *
 * https://github.com/text-mask/text-mask/issues/483#issuecomment-337259727
 */
var maskMaker = function maskMaker(mask, nonCharactersList) {
  return function (raw) {
    var length = raw.length;
    var nonDefault = nonCharactersList.some(function (characterIndex) {
      return characterIndex === length;
    });
    return nonDefault ? mask.slice(0, length) : mask;
  };
};

var mask = maskMaker(['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/], [4, 9]);

var PhoneField =
/** @class */
function (_super) {
  __extends(PhoneField, _super);

  function PhoneField(props) {
    var _this = _super.call(this, props) || this;

    if (props.value) {
      throw new Error('Passing a value argument to the MaskedField breaks the phone mask, use `defaultValue` to make this uncontrolled');
    }

    _this.cleanPhoneNumber = _this.cleanPhoneNumber.bind(_this);
    return _this;
  }

  PhoneField.prototype.cleanPhoneNumber = function (phone) {
    // Convert to string
    if (Array.isArray(phone)) {
      phone = phone.join('');
    } // Naive attempt at stripping the country code


    if (phone.length === 12 && phone.startsWith('+1')) {
      phone = phone.slice(2);
    } else if (phone.length === 11 && phone.startsWith('1')) {
      phone = phone.slice(1);
    } // Strip whitespace, parens, pluses, underscores and dashes


    phone = phone.replace(/[\s\(\)\+\-\_]/g, '');
    return phone;
  };

  PhoneField.prototype.render = function () {
    var _a = this.props,
        maskedFieldProps = _a.maskedFieldProps,
        defaultValue = _a.defaultValue,
        rest = __rest(_a, ["maskedFieldProps", "defaultValue"]);

    var cleanedValue = defaultValue && this.cleanPhoneNumber(defaultValue);
    return React.createElement(MaskedField, __assign({
      type: "tel",
      maskedFieldProps: __assign({
        mask: mask,
        guide: false
      }, maskedFieldProps),
      defaultValue: cleanedValue
    }, rest));
  };

  PhoneField.defaultProps = {
    autoFocus: false,
    placeholder: 'Enter a phone number'
  };
  return PhoneField;
}(React.Component);

var _extends$F = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$F(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ArrowDownIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$F(_ref, ["styles"]);

  return React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    d: "M3.115 5.295l-1.41 1.41 6 6 6-6-1.41-1.41-4.59 4.58z"
  }));
});

var styles$A = {"breakpoint-sm":"(min-width: 768px)","container":"styles_container__37SFI relative block","selectContainer":"styles_selectContainer__2eVbU relative flex flex-column","desktopSelectContainer":"styles_desktopSelectContainer__Dnfaz","label":"styles_label__3RRbT absolute bottom-0","desktopLabel":"styles_desktopLabel__280KV","errorText":"styles_errorText__wqFIb mt1","helpText":"styles_helpText__QzyYG mt1","icon":"styles_icon__d-btY absolute","desktopIcon":"styles_desktopIcon__3MZJy","select":"styles_select__hpaxr absolute bottom-0","isValid":"styles_isValid__3n9kQ","hasError":"styles_hasError__dAF_v","isDisabled":"styles_isDisabled__ZLEMh","hasValue":"styles_hasValue__2zVrJ","isLabelHidden":"styles_isLabelHidden__1Uo8e","isSelectedOptionDisabled":"styles_isSelectedOptionDisabled__1oTGd","desktopIsLabelHidden":"styles_desktopIsLabelHidden__2TfjT","desktopSelect":"styles_desktopSelect__3hZu-","xsmall":"styles_xsmall__3qqHQ","small":"styles_small__2TSPX","medium":"styles_medium__2oSB-","large":"styles_large__lUDsj","xlarge":"styles_xlarge__3_hFk","breakpointSm":"(min-width: 768px)"};

var Option = function Option(_a) {
  var option = _a.option;
  return React.createElement("option", __assign({
    value: option.value,
    disabled: option.disabled,
    selected: option.selected
  }, option.optionProps), option.label);
};

var ResponsiveSelect =
/** @class */
function (_super) {
  __extends(ResponsiveSelect, _super);

  function ResponsiveSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.selectRef = React.createRef();

    _this.checkPropInvariants(_this.props);

    _this.state = {
      hasValue: isUndefined(_this.props.defaultValue) ? undefined : !!_this.props.defaultValue
    };
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    return _this;
  }
  /**
   * Generate consistent ID for this input based on the props received:
   *  - Used to ensure the label and input are properly associated.
   *  - Must be consistent across server and browser renders.
   *  - Only used if an explicit `id` prop is not passed.
   */


  ResponsiveSelect.prototype.generateId = function () {
    return 'select-' + hash(this.props, {
      ignoreUnknown: true
    }).substr(0, 8);
  }; // Re-render component when ref is set. Ref assignment happens before componentDidMount lifecycle method
  // https://reactjs.org/docs/refs-and-the-dom.html#adding-a-ref-to-a-dom-element


  ResponsiveSelect.prototype.componentDidMount = function () {
    this.forceUpdate();
  };

  ResponsiveSelect.prototype.componentDidUpdate = function (prevProps) {
    // Warn about "valid" and "errorText" conflicts, but only if they've changed meaningfully
    //   i.e. only if one of those props was previously "false"
    if (this.props.errorText && this.props.valid && (!prevProps.errorText || !prevProps.valid)) {
      this.checkPropInvariants(this.props);
    }
  };

  ResponsiveSelect.prototype.checkPropInvariants = function (props) {
    var id = props.id || this.generateId();

    if (props.valid && props.errorText) {
      console.warn("Select (" + id + ") received both \"errorText\" and \"valid\" props. The error state will take precedence.");
    }
  };

  ResponsiveSelect.prototype.handleSelectChange = function (e) {
    // Only manage the input value if the value is not controlled by props
    if (isUndefined(this.props.value)) {
      this.setState({
        hasValue: !!(e.target.value && e.target.value.length > 0)
      });
    }

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  ResponsiveSelect.prototype.render = function () {
    var _a, _b, _c, _d, _e;

    var id = this.props.id || this.generateId();
    var testId = this.props.testId;
    var hasError = this.props.errorText !== undefined;
    var isValid = !!(this.props.valid && !hasError);
    var isDisabled = !!this.props.disabled;
    var isLabelHidden = !!this.props.labelHidden;
    var isSelectedOptionDisabled = this.selectRef.current && this.selectRef.current.options[this.selectRef.current.selectedIndex] && this.selectRef.current.options[this.selectRef.current.selectedIndex].disabled;
    var addDesktopStyles = this.props.display === 'standard' || this.props.display === 'responsive-inverse' && this.props.isMobile || this.props.display === 'responsive' && !this.props.isMobile;
    return React.createElement("div", {
      className: classnames(styles$A.container, styles$A[this.props.size], (_a = {}, _a[styles$A.hasError] = hasError, _a[styles$A.isValid] = isValid, _a[styles$A.isDisabled] = isDisabled, _a[styles$A.isSelectedOptionDisabled] = isSelectedOptionDisabled, _a[styles$A.isLabelHidden] = isLabelHidden, _a[styles$A.desktopIsLabelHidden] = addDesktopStyles, _a), this.props.className)
    }, React.createElement("div", {
      className: classnames(styles$A.selectContainer, (_b = {}, _b[styles$A.desktopSelectContainer] = addDesktopStyles, _b))
    }, React.createElement("label", {
      id: 'label-' + id,
      htmlFor: id,
      className: classnames(styles$A.label, (_c = {}, _c[styles$A.desktopLabel] = addDesktopStyles, _c))
    }, this.props.label), React.createElement("select", __assign({
      id: id,
      ref: this.selectRef,
      "data-testid": testId,
      className: classnames(styles$A.select, (_d = {}, _d[styles$A.desktopSelect] = addDesktopStyles, _d), this.props.selectClassName),
      defaultValue: this.props.defaultValue,
      disabled: this.props.disabled,
      name: this.props.name,
      onBlur: this.props.onBlur,
      onChange: this.handleSelectChange,
      onFocus: this.props.onFocus,
      value: this.props.value
    }, this.props.selectProps), this.props.options.map(function (optionOrOptionGroup) {
      if ('options' in optionOrOptionGroup) {
        return React.createElement("optgroup", __assign({
          label: optionOrOptionGroup.label,
          disabled: optionOrOptionGroup.disabled,
          key: 'optgroup' + hash(optionOrOptionGroup)
        }, optionOrOptionGroup.optGroupProps), optionOrOptionGroup.options.map(function (option) {
          return React.createElement(Option, {
            option: option,
            key: option.value.toString()
          });
        }));
      } else {
        return React.createElement(Option, {
          option: optionOrOptionGroup,
          key: optionOrOptionGroup.value.toString()
        });
      }
    })), this.props.icon && React.createElement(ArrowDownIcon, {
      className: classnames(styles$A.icon, (_e = {}, _e[styles$A.desktopIcon] = addDesktopStyles, _e))
    })), this.props.errorText && React.createElement("div", {
      className: styles$A.errorText
    }, this.props.errorText), this.props.helpText && React.createElement("div", {
      className: styles$A.helpText
    }, this.props.helpText));
  };

  ResponsiveSelect.defaultProps = {
    icon: true,
    size: 'medium',
    display: 'responsive'
  };
  return ResponsiveSelect;
}(React.Component);

var Select = function Select(_a) {
  var rest = __rest(_a, []);

  var isMobile = !useBreakpoint('sm');
  return React.createElement(ResponsiveSelect, __assign({
    isMobile: isMobile
  }, rest));
};

var styles$B = {"handle":"styles_handle__glQ0s block absolute","handle-tap-target":"styles_handle-tap-target__qFLI5 styles_handle__glQ0s block absolute","handle-label":"styles_handle-label__2ikRh absolute","handle-disabled":"styles_handle-disabled__2J2GM","handle-label-disabled":"styles_handle-label-disabled__2TGd_","handleTapTarget":"styles_handle-tap-target__qFLI5 styles_handle__glQ0s block absolute","handleLabel":"styles_handle-label__2ikRh absolute","handleDisabled":"styles_handle-disabled__2J2GM","handleLabelDisabled":"styles_handle-label-disabled__2TGd_"};

var Handle = function Handle(_a) {
  var _b, _c;

  var handle = _a.handle,
      _d = _a.domain,
      min = _d[0],
      max = _d[1],
      label = _a.label,
      format = _a.format,
      getHandleProps = _a.getHandleProps,
      _e = _a.disabled,
      disabled = _e === void 0 ? false : _e;
  var isInvalidDomain = min === max;
  var value = isInvalidDomain ? min : handle.value;
  return React.createElement(React.Fragment, null, label && React.createElement("span", {
    className: classnames(styles$B['handle-label'], (_b = {}, _b[styles$B['handle-label-disabled']] = disabled, _b)),
    style: {
      left: handle.percent + "%"
    }
  }, format(value)), React.createElement("div", __assign({
    className: styles$B['handle-tap-target'],
    style: {
      left: handle.percent + "%"
    }
  }, getHandleProps(handle.id))), React.createElement("div", {
    className: classnames(styles$B.handle, (_c = {}, _c[styles$B['handle-disabled']] = disabled, _c)),
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: handle.percent + "%"
    }
  }));
};

var styles$C = {"rail":"styles_rail__1SoxQ absolute","rail-tap-target":"styles_rail-tap-target__-9CVU styles_rail__1SoxQ absolute","rail-disabled":"styles_rail-disabled__1qsD4","railTapTarget":"styles_rail-tap-target__-9CVU styles_rail__1SoxQ absolute","railDisabled":"styles_rail-disabled__1qsD4"};

var Rail = function Rail(_a) {
  var _b;

  var getRailProps = _a.getRailProps,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c;
  return React.createElement(React.Fragment, null, React.createElement("div", __assign({
    className: styles$C['rail-tap-target']
  }, getRailProps())), React.createElement("div", {
    className: classnames(styles$C.rail, (_b = {}, _b[styles$C['rail-disabled']] = disabled, _b))
  }));
};

var styles$D = {"track":"styles_track__2xLak absolute","track-disabled":"styles_track-disabled__HegCk","trackDisabled":"styles_track-disabled__HegCk"};

var Track = function Track(_a) {
  var _b;

  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps,
      style = _a.style,
      className = _a.className,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      rest = __rest(_a, ["source", "target", "getTrackProps", "style", "className", "disabled"]);

  return React.createElement("div", __assign({
    className: classnames(className, styles$D.track, (_b = {}, _b[styles$D['track-disabled']] = disabled, _b)),
    style: {
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, rest));
};

var styles$E = {"slider":"styles_slider__2EqHe relative","label":"styles_label__2Ej9Q absolute","label-min":"styles_label-min__1KrPY styles_label__2Ej9Q absolute left-0","label-max":"styles_label-max__23Qm9 styles_label__2Ej9Q absolute right-0","label-disabled":"styles_label-disabled__1dr07","container":"styles_container__aFwuG","labelled-values":"styles_labelled-values__Pa8RL","labelled-domain":"styles_labelled-domain__3bK5G","labelMin":"styles_label-min__1KrPY styles_label__2Ej9Q absolute left-0","labelMax":"styles_label-max__23Qm9 styles_label__2Ej9Q absolute right-0","labelDisabled":"styles_label-disabled__1dr07","labelledValues":"styles_labelled-values__Pa8RL","labelledDomain":"styles_labelled-domain__3bK5G"};

//  See: https://sghall.github.io/react-compound-slider/#/component-api/slider

var modes = {
  cross: 1,
  block: 2,
  push: 3
};

var Slider = function Slider(_a) {
  var _b, _c, _d;

  var className = _a.className,
      domain = _a.domain,
      _e = _a.labelDomain,
      labelDomain = _e === void 0 ? false : _e,
      _f = _a.labelValues,
      labelValues = _f === void 0 ? false : _f,
      _g = _a.format,
      format = _g === void 0 ? function (num) {
    return num.toString();
  } : _g,
      _h = _a.mode,
      mode = _h === void 0 ? 'block' : _h,
      highlight = _a.highlight,
      values = _a.values,
      disabled = _a.disabled,
      rest = __rest(_a, ["className", "domain", "labelDomain", "labelValues", "format", "mode", "highlight", "values", "disabled"]);

  var isMultiSlider = values.length > 1;
  var hasLeftTrack = highlight === 'left' && !isMultiSlider;
  var hasRightTrack = highlight === 'right' && !isMultiSlider;
  var isInvalidDomain = domain[0] === domain[1]; // HACK: A slider can not have a domain [x, x], so we expand it by 1, disable the slider, and "select" the entire expanded domain

  var validatedDomain = isInvalidDomain ? [domain[0], domain[1] + 1] : domain;
  return React.createElement("div", {
    className: classnames(className, styles$E.container, (_b = {}, _b[styles$E['labelled-domain']] = labelDomain, _b[styles$E['labelled-values']] = labelValues, _b))
  }, React.createElement(Slider$1, __assign({
    mode: modes[mode],
    domain: validatedDomain,
    disabled: disabled || isInvalidDomain,
    values: isInvalidDomain ? validatedDomain : values,
    className: styles$E.slider
  }, rest), labelDomain && React.createElement(React.Fragment, null, React.createElement("span", {
    className: classnames(styles$E['label-min'], (_c = {}, _c[styles$E['label-disabled']] = disabled || isInvalidDomain, _c))
  }, format(domain[0])), React.createElement("span", {
    className: classnames(styles$E['label-max'], (_d = {}, _d[styles$E['label-disabled']] = disabled || isInvalidDomain, _d))
  }, format(domain[1]))), React.createElement(Rail$1, null, function (_a) {
    var getRailProps = _a.getRailProps;
    return React.createElement(Rail, {
      getRailProps: getRailProps
    });
  }), React.createElement(Handles, null, function (_a) {
    var handles = _a.handles,
        getHandleProps = _a.getHandleProps;
    return React.createElement(React.Fragment, null, handles.map(function (handle) {
      return React.createElement(Handle, {
        handle: handle,
        domain: domain,
        label: labelValues,
        format: format,
        getHandleProps: getHandleProps,
        disabled: disabled || isInvalidDomain,
        key: handle.id
      });
    }));
  }), React.createElement(Tracks, {
    left: hasLeftTrack,
    right: hasRightTrack
  }, function (_a) {
    var tracks = _a.tracks,
        getTrackProps = _a.getTrackProps;
    return React.createElement(React.Fragment, null, tracks.map(function (track) {
      return React.createElement(Track, {
        source: track.source,
        target: track.target,
        getTrackProps: getTrackProps,
        disabled: disabled || isInvalidDomain,
        key: track.id
      });
    }));
  })));
};

var _extends$G = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$G(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var PenIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$G(_ref, ["styles"]);

  return React.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), React.createElement("path", {
    d: "M13 7L9 3M5.5 14.5l-5 1 1-5 10-10 4 4z",
    stroke: "#233034",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});

var styles$F = {"container":"styles_container__2aoUG relative","icon":"styles_icon__38P03 absolute","input":"styles_input__39wxn"};

var InlineEditor = function InlineEditor(_a) {
  var inputRef = _a.inputRef,
      className = _a.className,
      rest = __rest(_a, ["inputRef", "className"]);

  return React.createElement("div", {
    className: classnames(styles$F.container, className)
  }, React.createElement("input", __assign({
    type: "text",
    ref: inputRef,
    className: styles$F.input
  }, rest)), React.createElement(PenIcon, {
    className: styles$F.icon
  }));
};

var styles$G = {"card":"styles_card__d_9QQ pb2 card"};

var styles$H = {"content":"styles_content__PKYpH p2 flex flex-column justify-end","gradient":"styles_gradient__1sltG"};

var SellableImage = function SellableImage(_a) {
  var contentClassName = _a.contentClassName,
      sizing = _a.sizing,
      children = _a.children,
      rest = __rest(_a, ["contentClassName", "sizing", "children"]); // Add a subtle gradient between the image and the children, if the image takes up the full container


  var showGradient = sizing === 'cover' && Children.toArray(children).filter(Boolean).length > 0;
  return React.createElement(FixedAspectRatioImage, __assign({
    contentClassName: classnames(styles$H.content, contentClassName, showGradient && styles$H.gradient),
    sizing: sizing,
    children: children
  }, rest));
};

var styles$I = {"logo":"styles_logo__h1NyV","placeholder":"styles_placeholder__Kfdja"};

var SellableBrandLogo = function SellableBrandLogo(_a) {
  var src = _a.src;

  if (!src) {
    return React.createElement("div", {
      className: styles$I.placeholder
    });
  }

  return React.createElement(Image, {
    src: src,
    height: 40,
    width: 40,
    imgixParams: {
      fit: 'clip'
    },
    className: styles$I.logo
  });
};

var styles$J = {"breakpoint-md":"(min-width: 960px)","container":"styles_container__1RdR0","title":"styles_title__fl5-v mb1","price":"styles_price__1IWyp","breakpointMd":"(min-width: 960px)"};

var SellableTitleAndPrice = function SellableTitleAndPrice(_a) {
  var title = _a.title,
      price = _a.price;
  return React.createElement("div", {
    className: styles$J.container
  }, React.createElement("div", {
    className: styles$J.title
  }, title), React.createElement("div", {
    className: styles$J.price
  }, price));
};

var styles$K = {"container":"styles_container__Qip_y flex items-center justify-between px2 pt2","attributes":"styles_attributes__2FX1I flex flex-wrap items-center m0 list-reset","attribute":"styles_attribute__3utPs mr2 flex items-center","icon":"styles_icon__2yMAb mr1","from":"styles_from__1_HIQ","price":"styles_price__bPAl1 bold"};

var SellableAttributesAndPrice = function SellableAttributesAndPrice(_a) {
  var _b = _a.attributes,
      attributes = _b === void 0 ? [] : _b,
      price = _a.price,
      priceIsMin = _a.priceIsMin;
  return React.createElement("div", {
    className: styles$K.container
  }, attributes.length > 0 && React.createElement("ul", {
    className: styles$K.attributes
  }, attributes.map(function (_a) {
    var Icon = _a.icon,
        value = _a.value;
    return React.createElement("li", {
      className: styles$K.attribute,
      key: Icon.toString() + value
    }, React.createElement(Icon, {
      className: styles$K.icon
    }), " ", value);
  })), React.createElement("div", {
    className: styles$K.price
  }, priceIsMin && React.createElement("div", {
    className: styles$K.from
  }, "FROM"), price));
};

var SellableCard = function SellableCard(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  return React.createElement("div", __assign({
    className: classnames(styles$G.card, className)
  }, rest));
};

var _extends$H = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$H(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ValidIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$H(_ref, ["styles"]);

  return React.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.724 5.692L7 11.71a.91.91 0 0 1-1.333 0L3.276 9.197a1.03 1.03 0 0 1 0-1.403.911.911 0 0 1 1.333 0l1.724 1.813 5.057-5.316a.91.91 0 0 1 1.334 0 1.026 1.026 0 0 1 0 1.401"
  }));
});

var _extends$I = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$I(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var InvalidIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$I(_ref, ["styles"]);

  return React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.308 11.705L8.002 9.401l-2.31 2.308a.99.99 0 1 1-1.401-1.4l2.31-2.31-2.31-2.308a.99.99 0 1 1 1.401-1.4l2.31 2.308 2.306-2.304a.99.99 0 1 1 1.401 1.4L9.404 8l2.305 2.305a.99.99 0 0 1 0 1.4.992.992 0 0 1-1.401 0z"
  }));
});

var styles$L = {"status":"styles_status__Ubcpj","stateIcon":"styles_stateIcon__20gK9","validIcon":"styles_validIcon__3KvfX styles_stateIcon__20gK9","invalidIcon":"styles_invalidIcon__ABI3r styles_stateIcon__20gK9","common":"styles_common__2_hpt","textarea":"styles_textarea__1Hw6m styles_common__2_hpt","has-icon":"styles_has-icon__35HPF","valid":"styles_valid__jS_Eh styles_has-icon__35HPF","invalid":"styles_invalid__2r95b styles_has-icon__35HPF","unvalidated":"styles_unvalidated__3X6tM","loading":"styles_loading__nxnGq styles_has-icon__35HPF","container":"styles_container__1uiiU","label":"styles_label__s5_kI bold mb1","error":"styles_error__FO-3K my1","errorIcon":"styles_errorIcon__2JHld col mr1","hasIcon":"styles_has-icon__35HPF"};

var TextAreaContainer =
/** @class */
function (_super) {
  __extends(TextAreaContainer, _super);

  function TextAreaContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  TextAreaContainer.prototype.handleChange = function (event) {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  TextAreaContainer.prototype.componentDidMount = function () {
    this.adjustHeight();
  };

  TextAreaContainer.prototype.componentDidUpdate = function () {
    this.adjustHeight();
  };

  TextAreaContainer.prototype.adjustHeight = function () {
    if (this.el && this.props.expand) {
      this.el.style.height = '0';
      this.el.style.height = this.el.scrollHeight + "px";
    }
  };

  TextAreaContainer.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        className = _b.className,
        label = _b.label,
        placeholder = _b.placeholder,
        loading = _b.loading,
        valid = _b.valid,
        inputRef = _b.inputRef,
        value = _b.value,
        errorText = _b.errorText,
        rows = _b.rows,
        textAreaProps = _b.textAreaProps,
        name = _b.name;
    var inputClasses = classnames(styles$L.textarea, (_a = {}, _a[styles$L.valid] = valid, _a[styles$L.invalid] = valid === false, _a[styles$L.unvalidated] = valid === undefined, _a[styles$L.loading] = loading, _a));
    var status;

    if (valid) {
      status = React.createElement(ValidIcon$2, {
        className: styles$L.validIcon
      });
    } else if (valid === false) {
      status = React.createElement(InvalidIcon, {
        className: styles$L.invalidIcon
      });
    }

    return React.createElement("label", {
      className: className
    }, label && React.createElement("div", {
      className: styles$L.label
    }, label), React.createElement("div", {
      className: styles$L.container
    }, React.createElement("textarea", __assign({
      onChange: this.handleChange,
      placeholder: placeholder,
      className: inputClasses,
      name: name,
      rows: rows,
      ref: function ref(el) {
        if (el) _this.el = el;
        if (inputRef) inputRef(el);
      },
      value: value
    }, textAreaProps)), status && React.createElement("div", {
      className: styles$L.status
    }, status)), errorText && React.createElement("div", {
      className: styles$L.error
    }, errorText));
  };

  TextAreaContainer.defaultProps = {
    expand: false
  };
  return TextAreaContainer;
}(React.Component);

var EmailField = function EmailField(props) {
  return React.createElement(TextField, __assign({
    type: "email",
    placeholder: "e.g. jdoe@gmail.com"
  }, props));
};

var numberMask$1 = createNumberMask({
  prefix: '$',
  allowDecimal: true
});

var InlineCurrencyEditor = function InlineCurrencyEditor(_a) {
  var _b = _a.placeholder,
      placeholder = _b === void 0 ? 'Enter Amount' : _b,
      maskedFieldProps = _a.maskedFieldProps,
      rest = __rest(_a, ["placeholder", "maskedFieldProps"]);

  return React.createElement(Masked, __assign({
    placeholder: placeholder,
    render: function render(ref, props) {
      return React.createElement(InlineEditor, __assign({
        inputRef: ref
      }, props, rest));
    },
    mask: numberMask$1
  }, maskedFieldProps));
};

var styles$M = {"container":"styles_container__2JaZo","suggestionsContainerOpen":"styles_suggestionsContainerOpen__1TSFX","suggestionsList":"styles_suggestionsList__2GyKj m0 list-reset","suggestion":"styles_suggestion__8VidE","suggestionHighlighted":"styles_suggestionHighlighted__1cHeP"};

var Typeahead =
/** @class */
function (_super) {
  __extends(Typeahead, _super);

  function Typeahead() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderInputComponent = function (inputProps) {
      return React.createElement(TextField, __assign({
        ref: _this.props.inputRef
      }, _this.props.textFieldProps, {
        // @ts-ignore onChange is typed incorrectly but is compatible
        inputProps: __assign({}, inputProps)
      }));
    };

    _this.renderSuggestion = function (suggestion, data) {
      var rawText = _this.props.getSuggestionValue(suggestion);

      var parts = parse(rawText, match(rawText, data.query));
      return React.createElement("div", null, parts.map(function (part) {
        if (part.highlight) {
          return React.createElement("b", {
            key: part.text
          }, part.text);
        } else {
          return part.text;
        }
      }));
    };

    return _this;
  }

  Typeahead.prototype.render = function () {
    return React.createElement(Autosuggest, __assign({
      focusInputOnSuggestionClick: false,
      renderInputComponent: this.props.renderInputComponent || this.renderInputComponent,
      renderSuggestion: this.props.renderSuggestion || this.renderSuggestion,
      theme: styles$M
    }, this.props));
  };

  return Typeahead;
}(React.Component);

var index$1 = React.forwardRef(function (props, ref) {
  return React.createElement(Typeahead, __assign({
    inputRef: ref
  }, props));
});

var StarRating = function StarRating(_a) {
  var _b = _a.starRatedColor,
      starRatedColor = _b === void 0 ? 'rgb(245, 87, 0)' : _b,
      _c = _a.starSpacing,
      starSpacing = _c === void 0 ? '0px' : _c,
      _d = _a.starDimension,
      starDimension = _d === void 0 ? '16px' : _d,
      _e = _a.numberOfStars,
      numberOfStars = _e === void 0 ? 5 : _e,
      _f = _a.svgIconViewBox,
      svgIconViewBox = _f === void 0 ? '0 0 16 16' : _f,
      _g = _a.svgIconPath,
      svgIconPath = _g === void 0 ? 'M8 .867l2.318 4.696 5.182.753-3.75 3.655.885 5.162L8 12.696l-4.635 2.437.885-5.162L.5 6.316l5.182-.753z' : _g,
      rating = _a.rating,
      rest = __rest(_a, ["starRatedColor", "starSpacing", "starDimension", "numberOfStars", "svgIconViewBox", "svgIconPath", "rating"]);

  return React.createElement(StarRatings, __assign({
    rating: rating,
    starRatedColor: starRatedColor,
    starSpacing: starSpacing,
    starDimension: starDimension,
    numberOfStars: numberOfStars,
    svgIconViewBox: svgIconViewBox,
    svgIconPath: svgIconPath
  }, rest));
};

var styles$N = {"lazy":"styles_lazy__3knV7","loaded":"styles_loaded__2AUy4"};

var ContentfulImage =
/** @class */
function (_super) {
  __extends(ContentfulImage, _super);

  function ContentfulImage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isVisible: false,
      loaded: false
    };
    return _this;
  } // This is for testing purposes only inside of Storybook


  ContentfulImage.prototype.getRootElement = function () {
    return null;
  };

  ContentfulImage.prototype.render = function () {
    var _a;

    var _this = this;

    var _b = this.props,
        src = _b.src,
        width = _b.width,
        height = _b.height,
        format = _b.format,
        fit = _b.fit,
        quality = _b.quality,
        _c = _b.lazyLoad,
        lazyLoad = _c === void 0 ? false : _c,
        className = _b.className,
        props = __rest(_b, ["src", "width", "height", "format", "fit", "quality", "lazyLoad", "className"]);

    var formattedSrc = src + "?";

    if (format) {
      if (format === 'png') {
        // Always request 8bit PNGs, this flag is invalid without a FM parameter even if it is already a PNG.
        // This is likely safe enough considering we only use transparent PNGs for logos and simple icons.
        formattedSrc += '&fm=png&fl=png8';
      } else if (format === 'jpg') {
        // Progressive JPGs suggest loading the lowest resolution first then loading the balance of the image's
        // quality in progressively higher detail. Network speeds should be fast enough, but this will help quality scores.
        formattedSrc += "&fm=jpg&fl=progressive";
      } else {
        formattedSrc += "&fm=" + format;
      }
    }

    if (quality && format !== 'png') {
      formattedSrc += "&q=" + quality;
    }

    if (fit) {
      formattedSrc += "&fit=" + fit;
    }

    if (width) {
      formattedSrc += "&w=" + width;
    }

    if (height) {
      formattedSrc += "&h=" + height;
    }

    if (!lazyLoad) {
      return React.createElement("img", __assign({
        src: formattedSrc,
        className: className
      }, props));
    }

    var _d = this.state,
        isVisible = _d.isVisible,
        loaded = _d.loaded;
    return React.createElement(Observer, {
      root: this.getRootElement(),
      onChange: function onChange(entry, unobserve) {
        if (entry.isIntersecting) {
          unobserve();
        }

        _this.setState({
          isVisible: entry.isIntersecting
        });
      }
    }, React.createElement("img", __assign({
      className: classnames(className, styles$N.lazy, (_a = {}, _a[styles$N.loaded] = loaded, _a)),
      onLoad: function onLoad() {
        _this.setState({
          loaded: true
        });
      },
      src: isVisible ? formattedSrc : ''
    }, props)));
  };

  return ContentfulImage;
}(PureComponent);

var index$2 = deprecate(ContentfulImage, 'The <ContentfulImage> component is deprecated. Use the <Image> component with `ContentAsset.imageUrl` instead.');

var styles$O = {"switch":"styles_switch__1hCbD relative inline-block","container":"styles_container__EKgI- absolute","activator":"styles_activator__38-Ay","label":"styles_label__2UL6I bold"};

var Switch = function Switch(_a) {
  var id = _a.id,
      className = _a.className,
      label = _a.label,
      props = __rest(_a, ["id", "className", "label"]);

  return React.createElement("div", {
    id: id,
    className: classnames(styles$O.switch, className)
  }, React.createElement("input", __assign({
    id: "toggle-switch-" + id,
    className: classnames(styles$O.container, styles$O.activator),
    type: "checkbox"
  }, omit(props, 'type', 'ref'))), React.createElement("label", {
    htmlFor: "toggle-switch-" + id
  }), label && React.createElement("span", {
    className: styles$O.label
  }, label));
};

var styles$P = {"dark":"styles_dark__3O3nQ","light":"styles_light__1NEMJ","tooltip":"styles_tooltip__m-tQi"};

var HoverCard = function HoverCard(_a) {
  var _b;

  var children = _a.children,
      className = _a.className,
      message = _a.message,
      _c = _a.theme,
      theme = _c === void 0 ? 'light' : _c,
      _d = _a.hideTargetOnMobile,
      hideTargetOnMobile = _d === void 0 ? false : _d,
      rest = __rest(_a, ["children", "className", "message", "theme", "hideTargetOnMobile"]);

  var isMobile = !useBreakpoint('sm');

  if (isMobile) {
    return hideTargetOnMobile ? null : React.createElement(React.Fragment, null, children);
  } else {
    // Using <span> is hack so that the child doesn't need to use React.forwardRef()
    return React.createElement(Tippy, __assign({
      content: message,
      className: classnames(styles$P.tooltip, className, (_b = {}, _b[styles$P.light] = theme === 'light', _b[styles$P.dark] = theme === 'dark', _b)),
      arrow: true
    }, rest), React.createElement("span", null, children));
  }
};

var styles$Q = {"tooltip":"styles_tooltip__1-Cnl","title":"styles_title__Rs5QA","message":"styles_message__J1L4j","footer":"styles_footer__1EHNO","content":"styles_content__3z-a4","small":"styles_small__wv2e-","large":"styles_large__1CJkQ","arrow":"styles_arrow__3UxS6"};

var HoverCard$1 = function HoverCard(_a) {
  var children = _a.children,
      message = _a.message,
      title = _a.title,
      subTitleContent = _a.subTitleContent,
      footerContent = _a.footerContent,
      size = _a.size,
      hoverCardClassName = _a.hoverCardClassName,
      placement = _a.placement,
      rest = __rest(_a, ["children", "message", "title", "subTitleContent", "footerContent", "size", "hoverCardClassName", "placement"]);

  var _b = useState(false),
      showBottomSheet = _b[0],
      setShowBottomSheet = _b[1];

  var isMobile = !useBreakpoint('sm');

  if (isMobile) {
    return React.createElement(React.Fragment, null, React.createElement(FancyModal, {
      isOpen: showBottomSheet,
      onRequestClose: function onRequestClose() {
        return setShowBottomSheet(false);
      }
    }, React.createElement(HoverCardWrapper, {
      placement: placement,
      title: title,
      message: message,
      subTitleContent: subTitleContent,
      footerContent: footerContent,
      size: size,
      hoverCardClassName: hoverCardClassName
    })), React.createElement("div", {
      onClick: function onClick() {
        return setShowBottomSheet(true);
      }
    }, children));
  } else {
    // Using <span> is hack so that the child doesn't need to use React.forwardRef()
    return React.createElement(Tippy$1, __assign({
      render: function render(attrs) {
        return React.createElement(HoverCardWrapper, {
          attrs: attrs,
          placement: placement,
          title: title,
          message: message,
          subTitleContent: subTitleContent,
          footerContent: footerContent,
          size: size,
          hoverCardClassName: hoverCardClassName
        });
      }
    }, rest), React.createElement("span", null, children));
  }
};

var HoverCardWrapper = function HoverCardWrapper(_a) {
  var _b;

  var attrs = _a.attrs,
      hoverCardClassName = _a.hoverCardClassName,
      title = _a.title,
      subTitleContent = _a.subTitleContent,
      footerContent = _a.footerContent,
      message = _a.message,
      _c = _a.size,
      size = _c === void 0 ? 'small' : _c;
  return React.createElement("div", __assign({}, attrs, {
    className: classnames(styles$Q.tooltip, hoverCardClassName, (_b = {}, _b[styles$Q.small] = size === 'small', _b[styles$Q.large] = size === 'large', _b))
  }), title && React.createElement("div", {
    className: styles$Q.title
  }, title), subTitleContent && React.createElement(HoverCardContent, null, subTitleContent), React.createElement("div", {
    className: styles$Q.message
  }, message), footerContent && React.createElement(HoverCardFooter, null, footerContent), React.createElement("div", {
    "data-popper-arrow": "",
    className: styles$Q.arrow
  }));
};

var HoverCardFooter = function HoverCardFooter(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$Q.footer, className)
  }, children);
};

var HoverCardContent = function HoverCardContent(_a) {
  var children = _a.children,
      className = _a.className;
  return React.createElement("div", {
    className: classnames(styles$Q.content, className)
  }, children);
};

var styles$R = {"columnHeader":"styles_columnHeader__o0xyS flex items-center","tableRow":"styles_tableRow__2t48J","tableHeader":"styles_tableHeader__2A-Ya","table":"styles_table__yi4wQ","noRowsFound":"styles_noRowsFound__M62SD"};

var styles$S = {"pagination":"styles_pagination__2RXkH flex","pageButton":"styles_pageButton__377Bg","disabled":"styles_disabled__UoFWZ","rowPerPage":"styles_rowPerPage__JRa34 flex","rowPerPageItem":"styles_rowPerPageItem__LDlva","chevronDown":"styles_chevronDown__3gLYB"};

var Pagination = function Pagination(_a) {
  var pages = _a.pages,
      page = _a.page,
      pageSize = _a.pageSize,
      onPageChange = _a.onPageChange,
      totalCount = _a.totalCount,
      onPageSizeChange = _a.onPageSizeChange,
      pageSizeOptions = _a.pageSizeOptions,
      allowPageSizeChange = _a.allowPageSizeChange;
  var currentPageNumber = page + 1;

  var filterPages = function filterPages(visiblePages, totalPages) {
    return visiblePages.filter(function (pageNumber) {
      return pageNumber <= totalPages;
    });
  };

  var getVisiblePages = function getVisiblePages(pageNumber, totalPages) {
    if (totalPages < 7) {
      return filterPages([1, 2, 3, 4, 5, 6], totalPages);
    } else if (pageNumber % 5 >= 0 && pageNumber > 4 && pageNumber + 2 < totalPages) {
      return [1, pageNumber - 1, pageNumber, pageNumber + 1, totalPages];
    } else if (pageNumber % 5 >= 0 && pageNumber > 4 && pageNumber + 2 >= totalPages) {
      return [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [1, 2, 3, 4, 5, totalPages];
    }
  };

  var visiblePages = getVisiblePages(currentPageNumber, pages);
  var startRowNumber = pageSize * page + 1;
  var endRowNumber = Math.min(pageSize * (page + 1), totalCount);
  return React.createElement("div", {
    className: styles$S.pagination
  }, allowPageSizeChange ? React.createElement("div", {
    className: styles$S.rowPerPage
  }, React.createElement(Select, {
    className: styles$S.rowPerPageSelector,
    label: "Rows per page",
    options: pageSizeOptions.map(function (v) {
      return {
        value: v,
        label: v.toString()
      };
    }).concat(pageSizeOptions.includes(pageSize) ? [] : {
      value: pageSize,
      label: pageSize.toString() + ' '
    }),
    value: pageSize,
    onChange: function onChange(evt) {
      return onPageSizeChange(parseInt(evt.target.value));
    }
  })) : React.createElement("div", null, "\xA0"), React.createElement("div", null, React.createElement("button", {
    className: styles$S.pageButton,
    onClick: function onClick() {
      if (currentPageNumber > 1) {
        onPageChange(currentPageNumber - 2);
      }
    },
    disabled: currentPageNumber === 1
  }, "<"), visiblePages.map(function (pageNumber, index, array) {
    var _a;

    var prevPageNumber = index > 0 && array[index - 1];
    return React.createElement(React.Fragment, {
      key: pageNumber
    }, prevPageNumber && pageNumber - prevPageNumber > 1 && '...', React.createElement("button", {
      className: classnames(styles$S.pageButton, (_a = {}, _a[styles$S.disabled] = pageNumber === currentPageNumber, _a)),
      onClick: function onClick() {
        return onPageChange(pageNumber - 1);
      }
    }, pageNumber));
  }), React.createElement("button", {
    className: styles$S.pageButton,
    onClick: function onClick() {
      if (currentPageNumber < pages) {
        onPageChange(currentPageNumber);
      }
    },
    disabled: currentPageNumber === pages
  }, ">")), React.createElement("div", null, startRowNumber, " - ", endRowNumber, " of ", totalCount));
};

var DataTable =
/** @class */
function (_super) {
  __extends(DataTable, _super);

  function DataTable(props) {
    var _this = _super.call(this, props) || this;

    _this.reactTableRef = createRef();
    _this.state = {
      pageSize: _this.props.defaultPageSize,
      selectAllChecked: false
    };
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    _this.toggleSelectAll = _this.toggleSelectAll.bind(_this);
    return _this;
  }

  DataTable.prototype.handleCheckboxChange = function (event) {
    var target = event.target;
    var selection = new Set(this.props.selection);

    if (target.checked) {
      selection.add(target.value);
    } else {
      selection.delete(target.value);
    }

    this.setState({
      selectAllChecked: this.state.selectAllChecked && event.target.checked
    });

    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(selection);
    }
  };

  DataTable.prototype.toggleSelectAll = function (event) {
    var visibleData = this.reactTableRef.current.getResolvedState().sortedData;
    var typeIds = visibleData.map(function (row) {
      return row._original.id;
    });
    var selection = new Set(this.props.selection);

    if (event.target.checked) {
      typeIds.forEach(function (id) {
        return selection.add(id);
      });
    } else {
      typeIds.forEach(function (id) {
        return selection.delete(id);
      });
    }

    this.setState({
      selectAllChecked: event.target.checked
    });

    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(selection);
    }
  };

  DataTable.prototype.createMultiSelectColumn = function () {
    var _this = this;

    if (this.props.selection && this.props.onSelectionChange) {
      var selection_1 = this.props.selection;
      var column = {
        id: 'checkbox',
        Cell: function Cell(row) {
          // @ts-ignore
          var id = row.original.id;
          return React.createElement(Box, {
            justify: "start",
            spacing: "extra-tight"
          }, React.createElement(Checkbox, {
            value: id,
            checked: selection_1.has(id),
            onChange: _this.handleCheckboxChange
          }));
        },
        maxWidth: 100,
        Header: function Header() {
          return React.createElement(Box, {
            justify: "start",
            spacing: "extra-tight",
            items: "center"
          }, React.createElement(Checkbox, {
            checked: _this.state.selectAllChecked,
            className: styles$R.selectAll,
            onChange: _this.toggleSelectAll
          }), selection_1.size ? "(" + selection_1.size + ")" : '');
        },
        sortable: false
      };
      return [column];
    } else {
      return [];
    }
  };

  DataTable.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        onFetchData = _a.onFetchData,
        defaultPageSize = _a.defaultPageSize,
        allowPageSizeChange = _a.allowPageSizeChange,
        data = _a.data,
        loading = _a.loading,
        totalCount = _a.totalCount,
        columns = _a.columns,
        defaultSorted = _a.defaultSorted;
    return React.createElement(ReactTable, {
      ref: this.reactTableRef,
      getTheadProps: function getTheadProps() {
        return {
          className: styles$R.tableHeader
        };
      },
      getTrProps: function getTrProps() {
        return {
          className: styles$R.tableRow
        };
      },
      getTheadThProps: function getTheadThProps() {
        return {
          className: styles$R.columnHeader
        };
      },
      PaginationComponent: function PaginationComponent(props) {
        return totalCount < 0 ? React.createElement("div", null, "\xA0") : React.createElement(Pagination, __assign({
          allowPageSizeChange: allowPageSizeChange,
          totalCount: totalCount
        }, props));
      },
      columns: this.createMultiSelectColumn().concat(columns),
      data: data,
      className: "-highlight " + styles$R.table,
      minRows: 0,
      defaultPageSize: defaultPageSize,
      pageSize: onFetchData ? this.state.pageSize : undefined,
      manual: onFetchData ? true : false,
      sortable: onFetchData ? false : undefined,
      onFetchData: onFetchData ? function (_a) {
        var pageSize = _a.pageSize,
            page = _a.page,
            sorted = _a.sorted;
        var sortBy = sorted && sorted.length > 0 ? {
          columnId: sorted[0].id,
          desc: sorted[0].desc
        } : undefined;
        onFetchData(pageSize, page, sortBy);
      } : undefined,
      loading: loading,
      pages: this.props.onFetchData && totalCount >= 0 ? Math.ceil(totalCount / this.state.pageSize) : undefined,
      onPageSizeChange: function onPageSizeChange(pageSize) {
        _this.setState({
          pageSize: pageSize
        });
      },
      defaultSorted: onFetchData ? undefined : defaultSorted
    });
  };

  return DataTable;
}(React.Component);

export { Avatar, Badge, Box, BubbleLoader, Button, Calendar, CalendarContext, Card, Checkbox, CircleLoader, index$2 as ContentfulImage, CurrencyField, DataTable, DataTable as DataTableProps, DatePaginator, DatePicker as DateRangePicker, DepartmentIcon, EmailField, ExpertProfileHighlightIcon, FancyContent, FancyModal, FancyShowcase, FixedAspectRatioImage, FixedFooter, Footer, FormattedDateRange, FullBlockLoader, FullPageLoader, GlobalLoader, ResponsiveGrid as Grid, GridItem, HoverCard$1 as HoverCard, index as Icon, Image, InlineCurrencyEditor, InlineEditor as InlineTextEditor, LazysizesSnippet, Logo, MaskedField, Modal, ModalContent, ModalFooter, ModalTitle, Notification, PhoneField, Picture, Radio, Select, SellableAttributesAndPrice, SellableBrandLogo, SellableCard, SellableImage, SellableTitleAndPrice, SimpleModal, SingleDatePickerContainer as SingleDatePicker, SingleDatePickerWithTime, Slider, Source, StarRating, StickyFooter, Switch, TextAreaContainer as TextArea, TextField, TimeBlock, TimePicker, HoverCard as Tooltip, index$1 as Typeahead };
//# sourceMappingURL=index.esm.js.map
